import { Language } from "@/hooks/use-language";

export type TranslationKey = keyof typeof translations;

export const translations = {
  // CTA Section
  startCooperation: {
    pl: "Rozpocznij współpracę",
    en: "Start cooperation",
    uk: "Почати співпрацю",
    ru: "Начать сотрудничество"
  },
  useOurSupport: {
    pl: "Skorzystaj z naszego wsparcia",
    en: "Use our support",
    uk: "Скористайтеся нашою підтримкою",
    ru: "Воспользуйтесь нашей поддержкой"
  },
  chooseContactMethod: {
    pl: "Wybierz najdogodniejszą formę kontaktu i skonsultuj swoją sprawę z naszym zespołem specjalistów.",
    en: "Choose the most convenient form of contact and consult your case with our team of specialists.",
    uk: "Виберіть найзручнішу форму зв'язку та проконсультуйтеся з нашою командою спеціалістів.",
    ru: "Выберите наиболее удобную форму связи и проконсультируйтесь с нашей командой специалистов."
  },
  contactOnline: {
    pl: "Skontaktuj się online",
    en: "Contact us online",
    uk: "Зв'яжіться онлайн",
    ru: "Свяжитесь онлайн"
  },
  fillContactForm: {
    pl: "Wypełnij formularz kontaktowy, a nasz konsultant odpowie w ciągu 24h",
    en: "Fill out the contact form, and our consultant will respond within 24 hours",
    uk: "Заповніть контактну форму, і наш консультант відповість протягом 24 годин",
    ru: "Заполните контактную форму, и наш консультант ответит в течение 24 часов"
  },
  writeMessage: {
    pl: "Napisz wiadomość",
    en: "Write a message",
    uk: "Написати повідомлення",
    ru: "Написать сообщение"
  },
  planMeeting: {
    pl: "Zaplanuj spotkanie",
    en: "Plan a meeting",
    uk: "Запланувати зустріч",
    ru: "Запланировать встречу"
  },
  bookConsultationTime: {
    pl: "Zarezerwuj termin konsultacji stacjonarnej lub zdalnej",
    en: "Book a time for an in-person or remote consultation",
    uk: "Забронюйте час для очної або віддаленої консультації",
    ru: "Забронируйте время для очной или удаленной консультации"
  },
  scheduleMeeting: {
    pl: "Umów spotkanie",
    en: "Schedule a meeting",
    uk: "Домовитися про зустріч",
    ru: "Договориться о встрече"
  },
  quickContact: {
    pl: "Szybki kontakt",
    en: "Quick contact",
    uk: "Швидкий контакт",
    ru: "Быстрый контакт"
  },
  instagramContact: {
    pl: "Skontaktuj się przez Instagram",
    en: "Contact us via Instagram",
    uk: "Зв'яжіться через Instagram",
    ru: "Свяжитесь через Instagram"
  },
  followUsOnInstagram: {
    pl: "Obserwuj nas na Instagramie",
    en: "Follow us on Instagram",
    uk: "Слідкуйте за нами в Instagram",
    ru: "Следите за нами в Instagram"
  },
  callDuringWorkHours: {
    pl: "Zadzwoń do nas w godzinach pracy 8:00-20:00 (pon-pt)",
    en: "Call us during working hours 8:00-20:00 (Mon-Fri)",
    uk: "Телефонуйте нам у робочий час 8:00-20:00 (пн-пт)",
    ru: "Звоните нам в рабочее время 8:00-20:00 (пн-пт)"
  },
  emailContact: {
    pl: "Kontakt mailowy",
    en: "Email contact",
    uk: "Контакт електронною поштою",
    ru: "Контакт по электронной почте"
  },
  sendInquiryDirectly: {
    pl: "Wyślij zapytanie bezpośrednio na naszą skrzynkę email",
    en: "Send an inquiry directly to our email inbox",
    uk: "Надішліть запит безпосередньо на нашу електронну пошту",
    ru: "Отправьте запрос непосредственно на наш электронный ящик"
  },
  additionalQuestions: {
    pl: "Masz dodatkowe pytania? Sprawdź sekcję FAQ lub przeczytaj szczegółowy opis naszych usług",
    en: "Do you have additional questions? Check the FAQ section or read a detailed description of our services",
    uk: "Маєте додаткові питання? Перегляньте розділ FAQ або прочитайте детальний опис наших послуг",
    ru: "Есть дополнительные вопросы? Проверьте раздел FAQ или прочитайте подробное описание наших услуг"
  },
  
  // Why us section
  whyUs: {
    pl: "Dlaczego my",
    en: "Why us",
    uk: "Чому ми",
    ru: "Почему мы"
  },
  ourAdvantages: {
    pl: "Poznaj nasze atuty",
    en: "Discover our advantages",
    uk: "Дізнайтеся про наші переваги",
    ru: "Узнайте о наших преимуществах"
  },
  ourAdvantagesDescription: {
    pl: "Jesteśmy zespołem ekspertów z wieloletnim doświadczeniem. Stawiamy na jakość usług, indywidualne podejście do klienta oraz terminowość realizacji.",
    en: "We are a team of experts with many years of experience. We focus on quality of services, individual approach to the client and timeliness of implementation.",
    uk: "Ми команда експертів з багаторічним досвідом. Ми зосереджуємося на якості послуг, індивідуальному підході до клієнта та своєчасності виконання.",
    ru: "Мы команда экспертов с многолетним опытом. Мы фокусируемся на качестве услуг, индивидуальном подходе к клиенту и своевременности выполнения."
  },
  yearsOfExperience: {
    pl: "Lat doświadczenia",
    en: "Years of experience",
    uk: "Років досвіду",
    ru: "Лет опыта"
  },
  satisfiedClients: {
    pl: "Zadowolonych klientów",
    en: "Satisfied clients",
    uk: "Задоволених клієнтів",
    ru: "Довольных клиентов"
  },
  successRate: {
    pl: "Skuteczność realizacji",
    en: "Success rate",
    uk: "Успішність реалізації",
    ru: "Успешность реализации"
  },
  // Services Section Description
  servicesComprehensiveDescription: {
    pl: "Oferujemy pełen zakres usług, aby uprościć Twoje życie i rozwijać Twój biznes.",
    en: "We offer a full range of services to simplify your life and develop your business.",
    uk: "Пропонуємо повний спектр послуг, щоб спростити ваше життя та розвивати ваш бізнес.",
    ru: "Предлагаем полный спектр услуг, чтобы упростить вашу жизнь и развивать ваш бизнес."
  },
  // Services Section Title and Badges
  ourServices: {
    pl: "Nasze Usługi",
    en: "Our Services",
    uk: "Наші Послуги",
    ru: "Наши Услуги"
  },
  specialistSupport: {
    pl: "W czym możemy",
    en: "How can we",
    uk: "Чим ми можемо",
    ru: "Чем мы можем"
  },
  inKeyAreas: {
    pl: "Ci pomóc?",
    en: "help you?",
    uk: "допомогти?",
    ru: "вам помочь?"
  },
  expertAdvice: {
    pl: "Eksperckie doradztwo",
    en: "Expert advice",
    uk: "Експертні консультації",
    ru: "Экспертные консультации"
  },
  effectiveSolutions: {
    pl: "Efektywne rozwiązania",
    en: "Effective solutions",
    uk: "Ефективні рішення",
    ru: "Эффективные решения"
  },
  popular: {
    pl: "Popularne",
    en: "Popular",
    uk: "Популярне",
    ru: "Популярное"
  },
  fastImplementation: {
    pl: "Szybka realizacja",
    en: "Fast implementation",
    uk: "Швидка реалізація",
    ru: "Быстрая реализация"
  },
  learnMore: {
    pl: "Dowiedz się więcej",
    en: "Learn more",
    uk: "Дізнатися більше",
    ru: "Узнать больше"
  },
  viewFullOffer: {
    pl: "Zapoznaj się z pełną ofertą",
    en: "View full offer",
    uk: "Ознайомтеся з повною пропозицією",
    ru: "Ознакомьтесь с полным предложением"
  },
  // Hero Section Translations
  heroTitle: {
    pl: "Kompleksowe usługi dla biznesu i życia codziennego",
    en: "Comprehensive services for business and everyday life",
    uk: "Комплексні послуги для бізнесу та повсякденного життя",
    ru: "Комплексные услуги для бизнеса и повседневной жизни"
  },
  heroDescription: {
    pl: "Od rejestracji spółek, przez obsługę prawną i księgowość, po legalizację pobytu i rejestrację pojazdów.",
    en: "From company registration, through legal and accounting services, to residence permits and vehicle registration.",
    uk: "Від реєстрації компаній, через юридичні та бухгалтерські послуги, до дозволів на проживання та реєстрації транспортних засобів.",
    ru: "От регистрации компаний, через юридические и бухгалтерские услуги, до разрешений на проживание и регистрации транспортных средств."
  },
  heroContactButton: {
    pl: "Zobacz Nasze Usługi",
    en: "See Our Services",
    uk: "Перегляньте Послуги",
    ru: "Посмотрите Наши Услуги"
  },
  
  // Navigation Menu Translations
  navHome: {
    pl: "Strona Główna",
    en: "Home",
    uk: "Головна",
    ru: "Главная"
  },
  
  // Privacy Policy Translations
  privacyPolicyTitle: {
    pl: "Polityka Prywatności",
    en: "Privacy Policy",
    uk: "Політика конфіденційності",
    ru: "Политика конфиденциальности"
  },
  privacyPolicyDescription: {
    pl: "Dowiedz się, jak przetwarzamy Twoje dane osobowe i jakie masz prawa w związku z korzystaniem z naszych usług.",
    en: "Learn how we process your personal data and what rights you have in connection with using our services.",
    uk: "Дізнайтеся, як ми обробляємо ваші персональні дані та які права ви маєте у зв'язку з використанням наших послуг.",
    ru: "Узнайте, как мы обрабатываем ваши персональные данные и какие права у вас есть в связи с использованием наших услуг."
  },
  privacyGeneralInfo: {
    pl: "Informacje ogólne",
    en: "General information",
    uk: "Загальна інформація",
    ru: "Общая информация"
  },
  privacyPurposeScope: {
    pl: "Cel i zakres zbierania danych",
    en: "Purpose and scope of data collection",
    uk: "Мета та обсяг збору даних",
    ru: "Цель и объем сбора данных"
  },
  privacyLegalBasis: {
    pl: "Podstawa prawna przetwarzania danych",
    en: "Legal basis for data processing",
    uk: "Правова основа обробки даних",
    ru: "Правовая основа обработки данных"
  },
  privacyStoragePeriod: {
    pl: "Okres przechowywania danych",
    en: "Data storage period",
    uk: "Період зберігання даних",
    ru: "Период хранения данных"
  },
  privacyDataRecipients: {
    pl: "Odbiorcy danych",
    en: "Data recipients",
    uk: "Одержувачі даних",
    ru: "Получатели данных"
  },
  privacyRights: {
    pl: "Prawa osób, których dane dotyczą",
    en: "Rights of data subjects",
    uk: "Права суб'єктів даних",
    ru: "Права субъектов данных"
  },
  privacySecurity: {
    pl: "Zabezpieczenie danych",
    en: "Data security",
    uk: "Безпека даних",
    ru: "Безопасность данных"
  },
  privacyCookies: {
    pl: "Cookies",
    en: "Cookies",
    uk: "Cookies",
    ru: "Cookies"
  },
  privacyChanges: {
    pl: "Zmiany Polityki Prywatności",
    en: "Changes to Privacy Policy",
    uk: "Зміни Політики конфіденційності",
    ru: "Изменения Политики конфиденциальности"
  },
  privacyContact: {
    pl: "Kontakt",
    en: "Contact",
    uk: "Контакт",
    ru: "Контакт"
  },
  privacyLastUpdate: {
    pl: "Data ostatniej aktualizacji:",
    en: "Last update date:",
    uk: "Дата останнього оновлення:",
    ru: "Дата последнего обновления:"
  },
  
  // Footer Translations
  footerSupportCenter: {
    pl: "1Group - Twoje centrum wsparcia w biznesie i życiu codziennym. Kompleksowe usługi dla firm i osób prywatnych. Zaufaj ekspertom i skup się na tym, co najważniejsze.",
    en: "1Group - Your support center in business and everyday life. Comprehensive services for companies and individuals. Trust experts and focus on what matters most.",
    uk: "1Group - Ваш центр підтримки у бізнесі та повсякденному житті. Комплексні послуги для компаній та приватних осіб. Довіртеся експертам і зосередьтеся на найважливішому.",
    ru: "1Group - Ваш центр поддержки в бизнесе и повседневной жизни. Комплексные услуги для компаний и частных лиц. Доверьтесь экспертам и сосредоточьтесь на самом важном."
  },
  footerServices: {
    pl: "Usługi",
    en: "Services",
    uk: "Послуги",
    ru: "Услуги"
  },
  footerCompanyServices: {
    pl: "Usługi dla firm",
    en: "Company services",
    uk: "Послуги для компаній",
    ru: "Услуги для компаний"
  },
  footerVehicleRegistration: {
    pl: "Rejestracja pojazdów",
    en: "Vehicle registration",
    uk: "Реєстрація транспортних засобів",
    ru: "Регистрация транспортных средств"
  },
  footerResidencePermit: {
    pl: "Legalizacja pobytu",
    en: "Residence permit",
    uk: "Легалізація перебування",
    ru: "Легализация пребывания"
  },
  footerAccounting: {
    pl: "Księgowość",
    en: "Accounting",
    uk: "Бухгалтерія",
    ru: "Бухгалтерия"
  },
  footerPricing: {
    pl: "Cennik",
    en: "Pricing",
    uk: "Ціни",
    ru: "Цены"
  },
  footerCompany: {
    pl: "Firma",
    en: "Company",
    uk: "Компанія",
    ru: "Компания"
  },
  footerFaq: {
    pl: "FAQ",
    en: "FAQ",
    uk: "FAQ",
    ru: "FAQ"
  },
  footerContact: {
    pl: "Kontakt",
    en: "Contact",
    uk: "Контакт",
    ru: "Контакт"
  },
  footerPrivacyPolicy: {
    pl: "Polityka Prywatności",
    en: "Privacy Policy",
    uk: "Політика конфіденційності",
    ru: "Политика конфиденциальности"
  },
  footerOpeningHours: {
    pl: "Godziny otwarcia",
    en: "Opening hours",
    uk: "Години роботи",
    ru: "Часы работы"
  },
  footerWorkingDays: {
    pl: "Poniedziałek - Piątek: 9:00 - 17:00",
    en: "Monday - Friday: 9:00 - 17:00",
    uk: "Понеділок - П'ятниця: 9:00 - 17:00",
    ru: "Понедельник - Пятница: 9:00 - 17:00"
  },
  footerWeekends: {
    pl: "Sobota - Niedziela: Zamknięte",
    en: "Saturday - Sunday: Closed",
    uk: "Субота - Неділя: Зачинено",
    ru: "Суббота - Воскресенье: Закрыто"
  },
  footerAddress: {
    pl: "Adres",
    en: "Address",
    uk: "Адреса",
    ru: "Адрес"
  },
  footerPhone: {
    pl: "Telefon",
    en: "Phone",
    uk: "Телефон",
    ru: "Телефон"
  },
  footerRouteMap: {
    pl: "Mapa dojazdu",
    en: "Route map",
    uk: "Карта проїзду",
    ru: "Карта проезда"
  },
  footerCopyright: {
    pl: "© 2025 1Group. Wszelkie prawa zastrzeżone.",
    en: "© 2025 1Group. All rights reserved.",
    uk: "© 2025 1Group. Усі права захищені.",
    ru: "© 2025 1Group. Все права защищены."
  },
  navServices: {
    pl: "Usługi",
    en: "Services",
    uk: "Послуги",
    ru: "Услуги"
  },
  navPricing: {
    pl: "Oferta",
    en: "Pricing",
    uk: "Ціни",
    ru: "Цены"
  },
  navFaq: {
    pl: "FAQ",
    en: "FAQ",
    uk: "FAQ",
    ru: "FAQ"
  },
  navContact: {
    pl: "Kontakt",
    en: "Contact",
    uk: "Контакт",
    ru: "Контакт"
  },
  navBusinessServices: {
    pl: "Dla biznesu",
    en: "For business",
    uk: "Для бізнесу",
    ru: "Для бизнеса"
  },
  navVehicleRegistration: {
    pl: "Rejestracja pojazdów",
    en: "Vehicle registration",
    uk: "Реєстрація транспортних засобів",
    ru: "Регистрация транспортных средств"
  },
  navResidencePermit: {
    pl: "Legalizacja pobytu",
    en: "Residence permit",
    uk: "Легалізація перебування",
    ru: "Легализация пребывания"
  },
  
  // FAQ Page Translations
  faqTitle: {
    pl: "Najczęściej Zadawane Pytania",
    en: "Frequently Asked Questions",
    uk: "Найчастіші Запитання",
    ru: "Часто Задаваемые Вопросы"
  },
  faqDescription: {
    pl: "Znajdź odpowiedzi na najczęściej zadawane pytania dotyczące naszych usług. Nie znalazłeś odpowiedzi? Zadaj nam pytanie!",
    en: "Find answers to the most frequently asked questions about our services. Didn't find your answer? Ask us a question!",
    uk: "Знайдіть відповіді на найчастіші запитання про наші послуги. Не знайшли відповідь? Задайте нам запитання!",
    ru: "Найдите ответы на часто задаваемые вопросы о наших услугах. Не нашли ответ? Задайте нам вопрос!"
  },
  faqSearch: {
    pl: "Szukaj w FAQ...",
    en: "Search in FAQ...",
    uk: "Пошук у FAQ...",
    ru: "Поиск в FAQ..."
  },
  faqNoResults: {
    pl: "Nie znaleziono wyników dla",
    en: "No results found for",
    uk: "Не знайдено результатів для",
    ru: "Не найдено результатов для"
  },
  faqAllQuestions: {
    pl: "Wszystkie pytania",
    en: "All questions",
    uk: "Всі запитання",
    ru: "Все вопросы"
  },
  faqTabAll: {
    pl: "Wszystkie",
    en: "All",
    uk: "Всі",
    ru: "Все"
  },
  faqTabCompany: {
    pl: "Firmy",
    en: "Companies",
    uk: "Компанії",
    ru: "Компании"
  },
  faqTabAuto: {
    pl: "Auto",
    en: "Auto",
    uk: "Авто",
    ru: "Авто"
  },
  faqTabSupport: {
    pl: "Wsparcie",
    en: "Support",
    uk: "Підтримка",
    ru: "Поддержка"
  },
  faqTabTax: {
    pl: "Księgowość",
    en: "Accounting",
    uk: "Бухгалтерія",
    ru: "Бухгалтерия"
  },
  faqCompanyServices: {
    pl: "Usługi dla firm",
    en: "Company Services",
    uk: "Послуги для компаній",
    ru: "Услуги для компаний"
  },
  faqAutoServices: {
    pl: "Usługi motoryzacyjne",
    en: "Automotive Services",
    uk: "Автомобільні послуги",
    ru: "Автомобильные услуги"
  },
  faqLegalSupport: {
    pl: "Wsparcie prawne i administracyjne",
    en: "Legal and Administrative Support",
    uk: "Юридична та адміністративна підтримка",
    ru: "Юридическая и административная поддержка"
  },
  faqAccountingServices: {
    pl: "Usługi księgowe",
    en: "Accounting Services",
    uk: "Бухгалтерські послуги",
    ru: "Бухгалтерские услуги"
  },
  faqAskQuestion: {
    pl: "Nie znalazłeś odpowiedzi na swoje pytanie?",
    en: "Didn't find the answer to your question?",
    uk: "Не знайшли відповідь на своє запитання?",
    ru: "Не нашли ответ на свой вопрос?"
  },
  faqAskDescription: {
    pl: "Zadaj nam pytanie, a nasi specjaliści odpowiedzą najszybciej, jak to możliwe.",
    en: "Ask us a question, and our specialists will answer as soon as possible.",
    uk: "Задайте нам запитання, і наші спеціалісти дадуть відповідь якомога швидше.",
    ru: "Задайте нам вопрос, и наши специалисты ответят как можно скорее."
  },
  faqAskButton: {
    pl: "Zadaj pytanie",
    en: "Ask a question",
    uk: "Задати запитання",
    ru: "Задать вопрос"
  },
  faqDialogTitle: {
    pl: "Zadaj nam pytanie",
    en: "Ask us a question",
    uk: "Задайте нам запитання",
    ru: "Задайте нам вопрос"
  },
  faqFormName: {
    pl: "Imię",
    en: "Name",
    uk: "Ім'я",
    ru: "Имя"
  },
  faqFormNamePlaceholder: {
    pl: "Wprowadź swoje imię",
    en: "Enter your name",
    uk: "Введіть своє ім'я",
    ru: "Введите свое имя"
  },
  faqFormEmail: {
    pl: "Email",
    en: "Email",
    uk: "Email",
    ru: "Email"
  },
  faqFormEmailPlaceholder: {
    pl: "twoj@email.com",
    en: "your@email.com",
    uk: "твоя@пошта.com",
    ru: "твоя@почта.com"
  },
  faqFormQuestion: {
    pl: "Twoje pytanie",
    en: "Your question",
    uk: "Ваше запитання",
    ru: "Ваш вопрос"
  },
  faqFormQuestionPlaceholder: {
    pl: "Wpisz swoje pytanie...",
    en: "Type your question...",
    uk: "Введіть своє запитання...",
    ru: "Введите свой вопрос..."
  },
  faqFormSubmit: {
    pl: "Wyślij pytanie",
    en: "Send question",
    uk: "Надіслати запитання",
    ru: "Отправить вопрос"
  },
  faqFormSuccess: {
    pl: "Dziękujemy za pytanie! Odpowiemy najszybciej jak to możliwe.",
    en: "Thank you for your question! We will answer as soon as possible.",
    uk: "Дякуємо за запитання! Ми відповімо якомога швидше.",
    ru: "Спасибо за вопрос! Мы ответим как можно скорее."
  },
  faqValidationNameRequired: {
    pl: "Imię jest wymagane",
    en: "Name is required",
    uk: "Ім'я обов'язкове",
    ru: "Имя обязательно"
  },
  faqValidationEmailInvalid: {
    pl: "Nieprawidłowy adres email",
    en: "Invalid email address",
    uk: "Неправильна адреса електронної пошти",
    ru: "Неправильный адрес электронной почты"
  },
  faqValidationQuestionRequired: {
    pl: "Pytanie musi zawierać co najmniej 10 znaków",
    en: "Question must be at least 10 characters",
    uk: "Запитання повинно містити щонайменше 10 символів",
    ru: "Вопрос должен содержать не менее 10 символов"
  },
  
  // Company FAQ
  faqCompany1Question: {
    pl: "Jak szybko mogę zarejestrować spółkę?",
    en: "How quickly can I register a company?",
    uk: "Як швидко я можу зареєструвати компанію?",
    ru: "Как быстро я могу зарегистрировать компанию?"
  },
  faqCompany1Answer: {
    pl: "Rejestracja spółki z o.o. przez system S24 zazwyczaj zajmuje od 24 do 48 godzin. W przypadku rejestracji tradycyjnej u notariusza, proces może potrwać do 14 dni. Pomożemy Ci wybrać najkorzystniejszą opcję.",
    en: "Registration of an LLC through the S24 system usually takes 24 to 48 hours. In the case of traditional registration at a notary, the process can take up to 14 days. We will help you choose the most favorable option.",
    uk: "Реєстрація ТОВ через систему S24 зазвичай займає від 24 до 48 годин. У випадку традиційної реєстрації у нотаріуса процес може тривати до 14 днів. Ми допоможемо вам обрати найвигідніший варіант.",
    ru: "Регистрация ООО через систему S24 обычно занимает от 24 до 48 часов. В случае традиционной регистрации у нотариуса процесс может занять до 14 дней. Мы поможем вам выбрать наиболее выгодный вариант."
  },
  faqCompany2Question: {
    pl: "Jakie dokumenty są potrzebne do rejestracji spółki?",
    en: "What documents are needed to register a company?",
    uk: "Які документи потрібні для реєстрації компанії?",
    ru: "Какие документы нужны для регистрации компании?"
  },
  faqCompany2Answer: {
    pl: "Do rejestracji spółki z o.o. potrzebujesz: danych osobowych wszystkich wspólników (imię, nazwisko, adres, PESEL), informacji o kapitale zakładowym i podziale udziałów, adresu siedziby firmy, przedmiotu działalności (kody PKD), danych zarządu. Przy rejestracji przez S24 wymagane jest posiadanie profilu zaufanego lub podpisu elektronicznego.",
    en: "To register an LLC, you need: personal data of all partners (name, surname, address, PESEL), information about share capital and distribution of shares, company headquarters address, subject of activity (PKD codes), management data. When registering through S24, a trusted profile or electronic signature is required.",
    uk: "Для реєстрації ТОВ вам потрібні: особисті дані всіх партнерів (ім'я, прізвище, адреса, PESEL), інформація про статутний капітал та розподіл часток, адреса штаб-квартири компанії, предмет діяльності (коди PKD), дані керівництва. При реєстрації через S24 потрібен довірений профіль або електронний підпис.",
    ru: "Для регистрации ООО вам нужны: личные данные всех партнеров (имя, фамилия, адрес, PESEL), информация о уставном капитале и распределении долей, адрес штаб-квартиры компании, предмет деятельности (коды PKD), данные руководства. При регистрации через S24 требуется доверенный профиль или электронная подпись."
  },
  faqCompany3Question: {
    pl: "Ile kosztuje rejestracja spółki z o.o.?",
    en: "How much does it cost to register an LLC?",
    uk: "Скільки коштує реєстрація ТОВ?",
    ru: "Сколько стоит регистрация ООО?"
  },
  faqCompany3Answer: {
    pl: "Koszt rejestracji spółki z o.o. to od 1500 zł netto (nasza usługa) plus opłaty urzędowe: 350 zł za rejestrację w KRS przy metodzie tradycyjnej lub 250 zł przy S24 oraz 100 zł za ogłoszenie w MSiG. Dodatkowo należy uwzględnić koszt notariusza przy metodzie tradycyjnej (około 600-1000 zł).",
    en: "The cost of registering an LLC starts from 1500 PLN net (our service) plus official fees: 350 PLN for KRS registration with the traditional method or 250 PLN with S24, and 100 PLN for announcement in MSiG. Additionally, you should consider the notary cost with the traditional method (about 600-1000 PLN).",
    uk: "Вартість реєстрації ТОВ становить від 1500 злотих нетто (наша послуга) плюс офіційні збори: 350 злотих за реєстрацію в KRS при традиційному методі або 250 злотих при S24, і 100 злотих за оголошення в MSiG. Додатково слід врахувати вартість нотаріуса при традиційному методі (близько 600-1000 злотих).",
    ru: "Стоимость регистрации ООО составляет от 1500 злотых нетто (наша услуга) плюс официальные сборы: 350 злотых за регистрацию в KRS при традиционном методе или 250 злотых при S24, и 100 злотых за объявление в MSiG. Дополнительно следует учесть стоимость нотариуса при традиционном методе (около 600-1000 злотых)."
  },
  faqCompany4Question: {
    pl: "Jak działa adres wirtualny?",
    en: "How does a virtual address work?",
    uk: "Як працює віртуальна адреса?",
    ru: "Как работает виртуальный адрес?"
  },
  faqCompany4Answer: {
    pl: "Adres wirtualny to usługa wynajmu adresu do rejestracji firmy oraz do celów korespondencyjnych. Odbieramy Twoją pocztę, skanujemy ją i przesyłamy na Twój adres e-mail. To idealne rozwiązanie, aby obniżyć koszty i zachować profesjonalny wizerunek. Oferujemy prestiżowy adres w centrum Poznania.",
    en: "A virtual address is a service of renting an address for company registration and correspondence purposes. We receive your mail, scan it and send it to your email address. It's an ideal solution to reduce costs and maintain a professional image. We offer a prestigious address in the center of Poznań.",
    uk: "Віртуальна адреса - це послуга оренди адреси для реєстрації компанії та кореспонденції. Ми отримуємо вашу пошту, скануємо її та надсилаємо на вашу електронну адресу. Це ідеальне рішення для зниження витрат і підтримки професійного іміджу. Ми пропонуємо престижну адресу в центрі Познані.",
    ru: "Виртуальный адрес - это услуга аренды адреса для регистрации компании и корреспонденции. Мы получаем вашу почту, сканируем ее и отправляем на ваш электронный адрес. Это идеальное решение для снижения затрат и поддержания профессионального имиджа. Мы предлагаем престижный адрес в центре Познани."
  },
  faqCompany5Question: {
    pl: "Czy mogę zmienić formę prawną mojej firmy?",
    en: "Can I change the legal form of my company?",
    uk: "Чи можу я змінити організаційно-правову форму моєї компанії?",
    ru: "Могу ли я изменить организационно-правовую форму моей компании?"
  },
  faqCompany5Answer: {
    pl: "Tak, możliwe jest przekształcenie formy prawnej, na przykład z jednoosobowej działalności gospodarczej w spółkę z o.o. lub ze spółki cywilnej w spółkę jawną. Proces wymaga odpowiednich dokumentów i zgłoszeń. Oferujemy kompleksowe wsparcie w takim przekształceniu, dbając o ciągłość działania Twojego biznesu.",
    en: "Yes, it is possible to transform the legal form, for example from a sole proprietorship to an LLC or from a civil partnership to a general partnership. The process requires appropriate documents and notifications. We offer comprehensive support in such a transformation, ensuring the continuity of your business.",
    uk: "Так, можливо трансформувати правову форму, наприклад, з індивідуального підприємця в ТОВ або з цивільного партнерства в повне товариство. Процес вимагає відповідних документів та повідомлень. Ми пропонуємо комплексну підтримку в такій трансформації, забезпечуючи безперервність вашого бізнесу.",
    ru: "Да, возможно трансформировать правовую форму, например, с индивидуального предпринимателя в ООО или с гражданского товарищества в полное товарищество. Процесс требует соответствующих документов и уведомлений. Мы предлагаем комплексную поддержку в такой трансформации, обеспечивая непрерывность вашего бизнеса."
  },
  
  // Auto FAQ
  faqAuto1Question: {
    pl: "Jakie dokumenty są potrzebne do rejestracji samochodu z UE?",
    en: "What documents are needed to register a car from the EU?",
    uk: "Які документи потрібні для реєстрації автомобіля з ЄС?",
    ru: "Какие документы нужны для регистрации автомобиля из ЕС?"
  },
  faqAuto1Answer: {
    pl: "Do rejestracji samochodu z UE potrzebujesz: dowodu własności pojazdu (faktura, umowa kupna-sprzedaży), dowodu rejestracyjnego, karty pojazdu (jeśli była wydana), aktualnego OC, zaświadczenia o pozytywnym wyniku badania technicznego, dokumentu potwierdzającego zapłatę akcyzy, dowodu osobistego oraz wniosku o rejestrację.",
    en: "To register a car from the EU, you need: proof of vehicle ownership (invoice, purchase-sale agreement), registration certificate, vehicle card (if issued), current liability insurance, certificate of positive technical inspection, document confirming payment of excise duty, ID card, and registration application.",
    uk: "Для реєстрації автомобіля з ЄС вам потрібні: доказ права власності на транспортний засіб (рахунок-фактура, договір купівлі-продажу), свідоцтво про реєстрацію, картка транспортного засобу (якщо видана), діюче страхування відповідальності, сертифікат про позитивний технічний огляд, документ, що підтверджує сплату акцизного збору, посвідчення особи та заява на реєстрацію.",
    ru: "Для регистрации автомобиля из ЕС вам нужны: доказательство права собственности на транспортное средство (счет-фактура, договор купли-продажи), свидетельство о регистрации, карта транспортного средства (если выдана), действующее страхование ответственности, сертификат о положительном техническом осмотре, документ, подтверждающий уплату акцизного сбора, удостоверение личности и заявление на регистрацию."
  },
  faqAuto2Question: {
    pl: "Ile czasu zajmuje rejestracja samochodu sprowadzonego z zagranicy?",
    en: "How long does it take to register a car imported from abroad?",
    uk: "Скільки часу займає реєстрація автомобіля, імпортованого з-за кордону?",
    ru: "Сколько времени занимает регистрация автомобиля, импортированного из-за границы?"
  },
  faqAuto2Answer: {
    pl: "Standardowy czas rejestracji samochodu sprowadzonego z zagranicy to około 2-3 dni robocze od momentu złożenia wszystkich wymaganych dokumentów. W przypadku skorzystania z naszych usług jesteśmy w stanie zarejestrować pojazd nawet w ciągu jednego dnia roboczego.",
    en: "The standard time for registering a car imported from abroad is about 2-3 business days from the submission of all required documents. If you use our services, we are able to register the vehicle even within one business day.",
    uk: "Стандартний час реєстрації автомобіля, імпортованого з-за кордону, становить близько 2-3 робочих днів з моменту подання всіх необхідних документів. Якщо ви скористаєтеся нашими послугами, ми зможемо зареєструвати транспортний засіб навіть протягом одного робочого дня.",
    ru: "Стандартное время регистрации автомобиля, импортированного из-за границы, составляет около 2-3 рабочих дней с момента подачи всех необходимых документов. Если вы воспользуетесь нашими услугами, мы сможем зарегистрировать транспортное средство даже в течение одного рабочего дня."
  },
  faqAuto3Question: {
    pl: "Czy pomagacie w odprawie celnej pojazdów spoza UE?",
    en: "Do you help with customs clearance for vehicles from outside the EU?",
    uk: "Чи допомагаєте ви з митним оформленням транспортних засобів з-за меж ЄС?",
    ru: "Помогаете ли вы с таможенным оформлением транспортных средств из-за пределов ЕС?"
  },
  faqAuto3Answer: {
    pl: "Tak, oferujemy kompleksową pomoc w odprawie celnej pojazdów sprowadzanych spoza Unii Europejskiej. Zajmujemy się przygotowaniem wszystkich niezbędnych dokumentów, reprezentacją przed urzędem celnym oraz doradztwem w zakresie optymalizacji kosztów związanych z cłem i podatkami.",
    en: "Yes, we offer comprehensive assistance in customs clearance for vehicles imported from outside the European Union. We handle the preparation of all necessary documents, representation before the customs office, and advice on optimizing costs related to customs duties and taxes.",
    uk: "Так, ми пропонуємо комплексну допомогу з митним оформленням транспортних засобів, імпортованих з-за меж Європейського Союзу. Ми займаємося підготовкою всіх необхідних документів, представництвом перед митницею та консультуванням щодо оптимізації витрат, пов'язаних з митними зборами та податками.",
    ru: "Да, мы предлагаем комплексную помощь с таможенным оформлением транспортных средств, импортированных из-за пределов Европейского Союза. Мы занимаемся подготовкой всех необходимых документов, представительством перед таможней и консультированием по оптимизации расходов, связанных с таможенными сборами и налогами."
  },
  faqAuto4Question: {
    pl: "Jakie ubezpieczenia komunikacyjne oferujecie?",
    en: "What motor insurance do you offer?",
    uk: "Які автострахування ви пропонуєте?",
    ru: "Какие автострахования вы предлагаете?"
  },
  faqAuto4Answer: {
    pl: "Oferujemy pełen zakres ubezpieczeń komunikacyjnych, w tym: obowiązkowe OC, AC (autocasco), NNW (następstwa nieszczęśliwych wypadków), Assistance (pomoc drogowa), ochronę szyb, opon oraz ubezpieczenia GAP. Współpracujemy z wiodącymi towarzystwami ubezpieczeniowymi, co pozwala nam zaoferować konkurencyjne stawki i szeroki zakres ochrony.",
    en: "We offer a full range of motor insurance, including: mandatory liability insurance, comprehensive insurance, accident consequences insurance, Assistance (roadside assistance), glass and tire protection, and GAP insurance. We cooperate with leading insurance companies, which allows us to offer competitive rates and a wide range of coverage.",
    uk: "Ми пропонуємо повний спектр автострахування, включаючи: обов'язкове страхування відповідальності, повне страхування, страхування від нещасних випадків, Assistance (допомога на дорозі), захист скла та шин, а також страхування GAP. Ми співпрацюємо з провідними страховими компаніями, що дозволяє нам пропонувати конкурентні тарифи та широкий спектр покриття.",
    ru: "Мы предлагаем полный спектр автострахования, включая: обязательное страхование ответственности, полное страхование, страхование от несчастных случаев, Assistance (помощь на дороге), защиту стекла и шин, а также страхование GAP. Мы сотрудничаем с ведущими страховыми компаниями, что позволяет нам предлагать конкурентные тарифы и широкий спектр покрытия."
  },
  
  // Support FAQ
  faqSupport1Question: {
    pl: "Czy mogę otrzymać PESEL bez meldunku?",
    en: "Can I get a PESEL number without registration of residence?",
    uk: "Чи можу я отримати номер PESEL без реєстрації місця проживання?",
    ru: "Могу ли я получить номер PESEL без регистрации места жительства?"
  },
  faqSupport1Answer: {
    pl: "Tak, istnieje możliwość uzyskania numeru PESEL na podstawie wniosku, w którym jako podstawę prawną wskazuje się konkretny przepis. Pomożemy Ci przygotować odpowiednie dokumenty i przejść przez całą procedurę.",
    en: "Yes, it is possible to obtain a PESEL number based on an application in which a specific legal provision is indicated as the legal basis. We will help you prepare the appropriate documents and go through the entire procedure.",
    uk: "Так, існує можливість отримати номер PESEL на підставі заяви, в якій конкретне правове положення вказується як правова основа. Ми допоможемо вам підготувати відповідні документи та пройти всю процедуру.",
    ru: "Да, существует возможность получить номер PESEL на основании заявления, в котором конкретное правовое положение указывается как правовое основание. Мы поможем вам подготовить соответствующие документы и пройти всю процедуру."
  },
  faqSupport2Question: {
    pl: "Jak długo trwa proces legalizacji pobytu w Polsce?",
    en: "How long does the process of legalizing residence in Poland take?",
    uk: "Як довго триває процес легалізації перебування в Польщі?",
    ru: "Как долго длится процесс легализации пребывания в Польше?"
  },
  faqSupport2Answer: {
    pl: "Czas oczekiwania na legalizację pobytu zależy od rodzaju dokumentu, o który się ubiegasz oraz od województwa. Średni czas oczekiwania na kartę pobytu czasowego to 6-9 miesięcy, natomiast na kartę stałego pobytu około 3-6 miesięcy. Dzięki naszemu doświadczeniu i znajomości procedur możemy znacznie usprawnić ten proces.",
    en: "The waiting time for residence legalization depends on the type of document you are applying for and the voivodeship. The average waiting time for a temporary residence card is 6-9 months, while for a permanent residence card it is about 3-6 months. Thanks to our experience and knowledge of procedures, we can significantly streamline this process.",
    uk: "Час очікування на легалізацію перебування залежить від типу документа, на який ви подаєте заяву, та від воєводства. Середній час очікування на картку тимчасового перебування становить 6-9 місяців, а на картку постійного перебування - близько 3-6 місяців. Завдяки нашому досвіду та знанню процедур ми можемо значно спростити цей процес.",
    ru: "Время ожидания легализации пребывания зависит от типа документа, на который вы подаете заявление, и от воеводства. Среднее время ожидания карточки временного пребывания составляет 6-9 месяцев, а карточки постоянного пребывания - около 3-6 месяцев. Благодаря нашему опыту и знанию процедур мы можем значительно упростить этот процесс."
  },
  faqSupport3Question: {
    pl: "Jakie dokumenty są potrzebne do legalizacji pobytu?",
    en: "What documents are needed for residence legalization?",
    uk: "Які документи потрібні для легалізації перебування?",
    ru: "Какие документы нужны для легализации пребывания?"
  },
  faqSupport3Answer: {
    pl: "Podstawowe dokumenty wymagane do legalizacji pobytu to: ważny paszport, zdjęcia biometryczne, wypełniony wniosek o pobyt, potwierdzenie zameldowania lub tytuł prawny do lokalu, ubezpieczenie zdrowotne oraz dokumenty potwierdzające cel pobytu (np. umowa o pracę, zaświadczenie z uczelni). W zależności od podstawy legalizacji mogą być wymagane dodatkowe dokumenty.",
    en: "Basic documents required for residence legalization are: valid passport, biometric photos, completed residence application, confirmation of registration or legal title to the premises, health insurance, and documents confirming the purpose of stay (e.g., employment contract, university certificate). Depending on the basis of legalization, additional documents may be required.",
    uk: "Основні документи, необхідні для легалізації перебування: дійсний паспорт, біометричні фотографії, заповнена заява про перебування, підтвердження реєстрації або юридичне право на приміщення, медичне страхування та документи, що підтверджують мету перебування (наприклад, трудовий договір, довідка з університету). Залежно від підстави легалізації можуть знадобитися додаткові документи.",
    ru: "Основные документы, необходимые для легализации пребывания: действительный паспорт, биометрические фотографии, заполненное заявление о пребывании, подтверждение регистрации или юридическое право на помещение, медицинское страхование и документы, подтверждающие цель пребывания (например, трудовой договор, справка из университета). В зависимости от основания легализации могут потребоваться дополнительные документы."
  },
  faqSupport4Question: {
    pl: "Czy oferujecie pomoc w uzyskaniu obywatelstwa polskiego?",
    en: "Do you offer assistance in obtaining Polish citizenship?",
    uk: "Чи пропонуєте ви допомогу в отриманні польського громадянства?",
    ru: "Предлагаете ли вы помощь в получении польского гражданства?"
  },
  faqSupport4Answer: {
    pl: "Tak, oferujemy kompleksowe wsparcie w procesie ubiegania się o obywatelstwo polskie. Pomagamy w przygotowaniu dokumentów, wypełnieniu wniosków oraz reprezentujemy klientów przed odpowiednimi urzędami. Doradzamy również w kwestii wyboru najkorzystniejszej ścieżki uzyskania obywatelstwa w zależności od indywidualnej sytuacji.",
    en: "Yes, we offer comprehensive support in the process of applying for Polish citizenship. We help in preparing documents, filling out applications, and represent clients before the relevant offices. We also advise on choosing the most favorable path to obtaining citizenship depending on the individual situation.",
    uk: "Так, ми пропонуємо комплексну підтримку в процесі подання заяви на польське громадянство. Ми допомагаємо у підготовці документів, заповненні заяв та представляємо клієнтів перед відповідними установами. Ми також консультуємо щодо вибору найвигіднішого шляху отримання громадянства залежно від індивідуальної ситуації.",
    ru: "Да, мы предлагаем комплексную поддержку в процессе подачи заявления на польское гражданство. Мы помогаем в подготовке документов, заполнении заявлений и представляем клиентов перед соответствующими учреждениями. Мы также консультируем по выбору наиболее выгодного пути получения гражданства в зависимости от индивидуальной ситуации."
  },
  
  // Tax FAQ
  faqTax1Question: {
    pl: "Czym różnią się pakiety księgowe BASIC, STANDARD i PREMIUM?",
    en: "What is the difference between BASIC, STANDARD and PREMIUM accounting packages?",
    uk: "Чим відрізняються бухгалтерські пакети BASIC, STANDARD і PREMIUM?",
    ru: "Чем отличаются бухгалтерские пакеты BASIC, STANDARD и PREMIUM?"
  },
  faqTax1Answer: {
    pl: "Pakiet BASIC obejmuje prowadzenie KPiR lub ryczałtu, do 50 dokumentów miesięcznie, podstawowe deklaracje podatkowe i ZUS. Pakiet STANDARD to pełna księgowość, do 100 dokumentów, wszystkie deklaracje, podstawowe doradztwo i dedykowany księgowy. Pakiet PREMIUM oferuje nieograniczoną liczbę dokumentów, kompleksowe doradztwo, kadry i płace do 10 pracowników oraz priorytetową obsługę z głównym księgowym.",
    en: "The BASIC package includes KPiR or flat-rate accounting, up to 50 documents per month, basic tax and ZUS declarations. The STANDARD package offers full accounting, up to 100 documents, all declarations, basic advisory and a dedicated accountant. The PREMIUM package offers an unlimited number of documents, comprehensive advisory, HR and payroll for up to 10 employees, and priority service with a chief accountant.",
    uk: "Пакет BASIC включає ведення KPiR або єдиного податку, до 50 документів на місяць, основні податкові декларації та декларації ZUS. Пакет STANDARD пропонує повну бухгалтерію, до 100 документів, усі декларації, базові консультації та виділеного бухгалтера. Пакет PREMIUM пропонує необмежену кількість документів, комплексні консультації, кадри та зарплату для до 10 працівників і пріоритетне обслуговування з головним бухгалтером.",
    ru: "Пакет BASIC включает ведение KPiR или единого налога, до 50 документов в месяц, основные налоговые декларации и декларации ZUS. Пакет STANDARD предлагает полную бухгалтерию, до 100 документов, все декларации, базовые консультации и выделенного бухгалтера. Пакет PREMIUM предлагает неограниченное количество документов, комплексные консультации, кадры и зарплату для до 10 работников и приоритетное обслуживание с главным бухгалтером."
  },
  faqTax2Question: {
    pl: "Czy można zmienić pakiet księgowy w trakcie roku?",
    en: "Can I change the accounting package during the year?",
    uk: "Чи можна змінити бухгалтерський пакет протягом року?",
    ru: "Можно ли изменить бухгалтерский пакет в течение года?"
  },
  faqTax2Answer: {
    pl: "Tak, oferujemy elastyczne podejście i możliwość zmiany pakietu księgowego w dowolnym momencie, w zależności od aktualnych potrzeb Twojej firmy. Zmiana pakietu jest bezpłatna i wchodzi w życie od następnego miesiąca rozliczeniowego.",
    en: "Yes, we offer a flexible approach and the possibility to change the accounting package at any time, depending on the current needs of your company. The package change is free and takes effect from the next billing month.",
    uk: "Так, ми пропонуємо гнучкий підхід і можливість змінити бухгалтерський пакет у будь-який час, залежно від поточних потреб вашої компанії. Зміна пакету безкоштовна і набуває чинності з наступного розрахункового місяця.",
    ru: "Да, мы предлагаем гибкий подход и возможность изменить бухгалтерский пакет в любое время, в зависимости от текущих потребностей вашей компании. Изменение пакета бесплатное и вступает в силу со следующего расчетного месяца."
  },
  faqTax3Question: {
    pl: "Jak wygląda proces przekazywania dokumentów księgowych?",
    en: "How does the process of transferring accounting documents work?",
    uk: "Як працює процес передачі бухгалтерських документів?",
    ru: "Как работает процесс передачи бухгалтерских документов?"
  },
  faqTax3Answer: {
    pl: "Dokumenty księgowe możesz dostarczać na kilka sposobów: osobiście w naszym biurze, wysyłając je pocztą lub kurierem, a także w formie elektronicznej (skany lub zdjęcia) przez dedykowany system lub email. W pakietach STANDARD i PREMIUM oferujemy również możliwość odbioru dokumentów bezpośrednio z siedziby Twojej firmy.",
    en: "You can deliver accounting documents in several ways: in person at our office, by mail or courier, as well as electronically (scans or photos) through a dedicated system or email. In STANDARD and PREMIUM packages, we also offer the option of collecting documents directly from your company's headquarters.",
    uk: "Ви можете доставляти бухгалтерські документи кількома способами: особисто в нашому офісі, поштою або кур'єром, а також електронно (скани або фотографії) через спеціальну систему або електронну пошту. У пакетах STANDARD і PREMIUM ми також пропонуємо можливість забирати документи безпосередньо з штаб-квартири вашої компанії.",
    ru: "Вы можете доставлять бухгалтерские документы несколькими способами: лично в нашем офисе, по почте или курьером, а также электронно (сканы или фотографии) через специальную систему или электронную почту. В пакетах STANDARD и PREMIUM мы также предлагаем возможность забирать документы непосредственно из штаб-квартиры вашей компании."
  },
  faqTax4Question: {
    pl: "Czy pomagacie w optymalizacji podatkowej?",
    en: "Do you help with tax optimization?",
    uk: "Чи допомагаєте ви з податковою оптимізацією?",
    ru: "Помогаете ли вы с налоговой оптимизацией?"
  },
  faqTax4Answer: {
    pl: "Tak, w ramach pakietów STANDARD i PREMIUM oferujemy doradztwo w zakresie legalnej optymalizacji podatkowej. Analizujemy sytuację finansową Twojej firmy i proponujemy rozwiązania, które pozwolą zmniejszyć obciążenia podatkowe zgodnie z obowiązującym prawem. Każda rekomendacja jest dostosowana do specyfiki Twojej działalności.",
    en: "Yes, as part of the STANDARD and PREMIUM packages, we offer advice on legal tax optimization. We analyze the financial situation of your company and propose solutions that will reduce tax burdens in accordance with applicable law. Each recommendation is tailored to the specifics of your business.",
    uk: "Так, у рамках пакетів STANDARD і PREMIUM ми пропонуємо консультації щодо законної податкової оптимізації. Ми аналізуємо фінансовий стан вашої компанії та пропонуємо рішення, які зменшать податкове навантаження відповідно до чинного законодавства. Кожна рекомендація адаптована до особливостей вашого бізнесу.",
    ru: "Да, в рамках пакетов STANDARD и PREMIUM мы предлагаем консультации по законной налоговой оптимизации. Мы анализируем финансовое положение вашей компании и предлагаем решения, которые уменьшат налоговую нагрузку в соответствии с действующим законодательством. Каждая рекомендация адаптирована к особенностям вашего бизнеса."
  },
  
  // Header Translations
  pricing: {
    pl: "Przejrzysty Cennik",
    en: "Clear Pricing",
    uk: "Прозорий прайс-лист",
    ru: "Прозрачный прайс-лист"
  },
  pricingDescription: {
    pl: "Oferujemy konkurencyjne ceny i elastyczne pakiety dostosowane do Twoich potrzeb. Poniżej znajdziesz orientacyjne ceny naszych usług.",
    en: "We offer competitive prices and flexible packages tailored to your needs. Below you will find indicative prices for our services.",
    uk: "Ми пропонуємо конкурентні ціни та гнучкі пакети, адаптовані до ваших потреб. Нижче ви знайдете орієнтовні ціни на наші послуги.",
    ru: "Мы предлагаем конкурентные цены и гибкие пакеты, адаптированные к вашим потребностям. Ниже вы найдете ориентировочные цены на наши услуги."
  },
  
  // Contact Page Translations
  contactUs: {
    pl: "Skontaktuj się z nami",
    en: "Contact us",
    uk: "Зв'яжіться з нами",
    ru: "Свяжитесь с нами"
  },
  contactDescription: {
    pl: "Chętnie odpowiemy na wszystkie Twoje pytania. Wypełnij formularz lub skontaktuj się z nami bezpośrednio.",
    en: "We will gladly answer all your questions. Fill out the form or contact us directly.",
    uk: "Ми з радістю відповімо на всі ваші запитання. Заповніть форму або зв'яжіться з нами безпосередньо.",
    ru: "Мы с радостью ответим на все ваши вопросы. Заполните форму или свяжитесь с нами напрямую."
  },
  writeToUs: {
    pl: "Napisz do nas",
    en: "Write to us",
    uk: "Напишіть нам",
    ru: "Напишите нам"
  },
  contactDetails: {
    pl: "Dane kontaktowe",
    en: "Contact details",
    uk: "Контактні дані",
    ru: "Контактные данные"
  },

  // Tabs Translations
  company: {
    pl: "DLA FIRM",
    en: "COMPANY",
    uk: "ДЛЯ КОМПАНІЙ",
    ru: "ДЛЯ КОМПАНИЙ"
  },
  auto: {
    pl: "AUTO",
    en: "AUTO",
    uk: "АВТО",
    ru: "АВТО"
  },
  support: {
    pl: "WSPARCIE",
    en: "SUPPORT",
    uk: "ПІДТРИМКА",
    ru: "ПОДДЕРЖКА"
  },
  accounting: {
    pl: "KSIĘGOWOŚĆ",
    en: "ACCOUNTING",
    uk: "БУХГАЛТЕРІЯ",
    ru: "БУХГАЛТЕРИЯ"
  },
  tax: {
    pl: "TAX",
    en: "TAX",
    uk: "TAX",
    ru: "TAX"
  },

  // Section Titles
  companyServicesTitle: {
    pl: "Cennik usług dla firm",
    en: "Company Services Pricing",
    uk: "Ціни на послуги для компаній",
    ru: "Цены на услуги для компаний"
  },
  autoServicesTitle: {
    pl: "Cennik usług motoryzacyjnych",
    en: "Automotive Services Pricing",
    uk: "Ціни на автомобільні послуги",
    ru: "Цены на автомобильные услуги"
  },
  supportServicesTitle: {
    pl: "Cennik usług wsparcia",
    en: "Support Services Pricing",
    uk: "Ціни на послуги підтримки",
    ru: "Цены на услуги поддержки"
  },
  accountingPackagesTitle: {
    pl: "Pakiety księgowe",
    en: "Accounting Packages",
    uk: "Бухгалтерські пакети",
    ru: "Бухгалтерские пакеты"
  },

  // Company Services
  companyServiceRegisterLLC: {
    pl: "Rejestracja spółki z o.o.",
    en: "LLC Registration",
    uk: "Реєстрація ТОВ",
    ru: "Регистрация ООО"
  },
  companyServiceRegisterSoleTrader: {
    pl: "Rejestracja JDG",
    en: "Sole Trader Registration",
    uk: "Реєстрація ФОП",
    ru: "Регистрация ИП"
  },
  companyServiceKRSChanges: {
    pl: "Zmiany w KRS",
    en: "KRS Changes",
    uk: "Зміни в KRS",
    ru: "Изменения в KRS"
  },
  companyServiceVirtualAddress: {
    pl: "Adres wirtualny",
    en: "Virtual Address",
    uk: "Віртуальна адреса",
    ru: "Виртуальный адрес"
  },
  companyServiceConsultation: {
    pl: "Konsultacja",
    en: "Consultation",
    uk: "Консультація",
    ru: "Консультация"
  },

  // Auto Services
  autoServiceRegisterEU: {
    pl: "Rejestracja auta z UE",
    en: "EU Car Registration",
    uk: "Реєстрація авто з ЄС",
    ru: "Регистрация авто из ЕС"
  },
  autoServiceRegisterNonEU: {
    pl: "Rejestracja auta spoza UE",
    en: "Non-EU Car Registration",
    uk: "Реєстрація авто не з ЄС",
    ru: "Регистрация авто не из ЕС"
  },
  autoServiceInsuranceOC: {
    pl: "Ubezpieczenie OC",
    en: "Liability Insurance",
    uk: "Страхування відповідальності",
    ru: "Страхование ответственности"
  },
  autoServiceInsuranceAC: {
    pl: "Ubezpieczenie AC",
    en: "Comprehensive Insurance",
    uk: "Повне страхування",
    ru: "Полное страхование"
  },
  autoServiceDeregister: {
    pl: "Wyrejestrowanie pojazdu",
    en: "Vehicle Deregistration",
    uk: "Зняття з реєстрації транспортного засобу",
    ru: "Снятие с учета транспортного средства"
  },

  // Support Services
  supportServiceLegalization: {
    pl: "Legalizacja pobytu",
    en: "Residence Legalization",
    uk: "Легалізація перебування",
    ru: "Легализация пребывания"
  },
  supportServicePESEL: {
    pl: "Uzyskanie numeru PESEL",
    en: "PESEL Number Acquisition",
    uk: "Отримання номера PESEL",
    ru: "Получение номера PESEL"
  },
  supportServiceRepresentation: {
    pl: "Reprezentacja przed urzędami (1h)",
    en: "Office Representation (1h)",
    uk: "Представництво в органах влади (1 год)",
    ru: "Представительство в органах власти (1 час)"
  },
  supportServiceTranslation: {
    pl: "Tłumaczenia przysięgłe (strona)",
    en: "Certified Translations (page)",
    uk: "Присяжні переклади (сторінка)",
    ru: "Присяжные переводы (страница)"
  },

  // Tax Packages
  taxPackageBasic: {
    pl: "BASIC",
    en: "BASIC",
    uk: "БАЗОВИЙ",
    ru: "БАЗОВЫЙ"
  },
  taxPackageStandard: {
    pl: "STANDARD",
    en: "STANDARD",
    uk: "СТАНДАРТ",
    ru: "СТАНДАРТ"
  },
  taxPackagePremium: {
    pl: "PREMIUM",
    en: "PREMIUM",
    uk: "ПРЕМІУМ",
    ru: "ПРЕМИУМ"
  },

  // Tax Package Features
  taxFeatureKPIR: {
    pl: "Prowadzenie KPiR lub ryczałt",
    en: "KPiR or flat-rate accounting",
    uk: "Ведення KPiR або єдиний податок",
    ru: "Ведение KPiR или единый налог"
  },
  taxFeatureDocuments50: {
    pl: "Do 50 dokumentów miesięcznie",
    en: "Up to 50 documents per month",
    uk: "До 50 документів на місяць",
    ru: "До 50 документов в месяц"
  },
  taxFeatureDocuments100: {
    pl: "Do 100 dokumentów miesięcznie",
    en: "Up to 100 documents per month",
    uk: "До 100 документів на місяць",
    ru: "До 100 документов в месяц"
  },
  taxFeatureUnlimitedDocuments: {
    pl: "Nieograniczona liczba dokumentów",
    en: "Unlimited number of documents",
    uk: "Необмежена кількість документів",
    ru: "Неограниченное количество документов"
  },
  taxFeatureTaxDeclarations: {
    pl: "Deklaracje podatkowe",
    en: "Tax declarations",
    uk: "Податкові декларації",
    ru: "Налоговые декларации"
  },
  taxFeatureZUSDeclarations: {
    pl: "Deklaracje ZUS",
    en: "ZUS declarations",
    uk: "Декларації ZUS",
    ru: "Декларации ZUS"
  },
  taxFeatureAllDeclarations: {
    pl: "Wszystkie deklaracje",
    en: "All declarations",
    uk: "Усі декларації",
    ru: "Все декларации"
  },
  taxFeatureFullAccounting: {
    pl: "Pełna księgowość",
    en: "Full accounting",
    uk: "Повна бухгалтерія",
    ru: "Полная бухгалтерия"
  },
  taxFeatureBasicAdvice: {
    pl: "Podstawowe doradztwo podatkowe",
    en: "Basic tax advisory",
    uk: "Базові податкові консультації",
    ru: "Базовое налоговое консультирование"
  },
  taxFeatureComprehensiveAdvice: {
    pl: "Kompleksowe doradztwo podatkowe",
    en: "Comprehensive tax advisory",
    uk: "Комплексні податкові консультації",
    ru: "Комплексное налоговое консультирование"
  },
  taxFeatureDedicatedAccountant: {
    pl: "Dedykowany księgowy",
    en: "Dedicated accountant",
    uk: "Виділений бухгалтер",
    ru: "Выделенный бухгалтер"
  },
  taxFeatureDedicatedChiefAccountant: {
    pl: "Dedykowany główny księgowy",
    en: "Dedicated chief accountant",
    uk: "Виділений головний бухгалтер",
    ru: "Выделенный главный бухгалтер"
  },
  taxFeaturePayroll: {
    pl: "Kadry i płace do 10 pracowników",
    en: "HR and payroll up to 10 employees",
    uk: "Кадри та зарплата до 10 працівників",
    ru: "Кадры и зарплата до 10 работников"
  },
  taxFeaturePrioritySupport: {
    pl: "Priorytetowa obsługa",
    en: "Priority support",
    uk: "Пріоритетна підтримка",
    ru: "Приоритетная поддержка"
  },
  taxFeatureEmailPhone: {
    pl: "Kontakt e-mail i telefoniczny",
    en: "Email and phone contact",
    uk: "Контакт електронною поштою та телефоном",
    ru: "Контакт по электронной почте и телефону"
  },

  // Price Prefixes
  priceFrom: {
    pl: "od",
    en: "from",
    uk: "від",
    ru: "от"
  },
  pricePerMonth: {
    pl: "/mies",
    en: "/month",
    uk: "/міс",
    ru: "/мес"
  },
  priceIndividual: {
    pl: "indywidualna wycena",
    en: "individual pricing",
    uk: "індивідуальна оцінка",
    ru: "индивидуальная оценка"
  },

  // Buttons
  buttonOrderService: {
    pl: "Zamów usługę",
    en: "Order service",
    uk: "Замовити послугу",
    ru: "Заказать услугу"
  },
  buttonBookConsultation: {
    pl: "Umów konsultację",
    en: "Book consultation",
    uk: "Записатися на консультацію",
    ru: "Записаться на консультацию"
  },
  buttonChoosePackage: {
    pl: "Wybierz pakiet",
    en: "Choose package",
    uk: "Вибрати пакет",
    ru: "Выбрать пакет"
  },

  // CTA Section
  ctaTitle: {
    pl: "Potrzebujesz indywidualnej wyceny?",
    en: "Need an individual quote?",
    uk: "Потрібна індивідуальна оцінка?",
    ru: "Нужна индивидуальная оценка?"
  },
  ctaDescription: {
    pl: "Skontaktuj się z nami, aby otrzymać szczegółową wycenę dopasowaną do Twoich potrzeb.",
    en: "Contact us to receive a detailed quote tailored to your needs.",
    uk: "Зв'яжіться з нами, щоб отримати детальну оцінку, адаптовану до ваших потреб.",
    ru: "Свяжитесь с нами, чтобы получить подробную оценку, адаптированную к вашим потребностям."
  },
  buttonFreeConsultation: {
    pl: "Umów bezpłatną konsultację",
    en: "Book a free consultation",
    uk: "Записатися на безкоштовну консультацію",
    ru: "Записаться на бесплатную консультацию"
  },

  // Dialog Titles
  dialogTitleBookConsultation: {
    pl: "Umów bezpłatną konsultację",
    en: "Book a free consultation",
    uk: "Записатися на безкоштовну консультацію",
    ru: "Записаться на бесплатную консультацию"
  },
  dialogTitleOrderService: {
    pl: "Zamówienie usługi",
    en: "Order service",
    uk: "Замовлення послуги",
    ru: "Заказ услуги"
  },

  // Form Fields
  formName: {
    pl: "Imię",
    en: "Name",
    uk: "Ім'я",
    ru: "Имя"
  },
  formEmail: {
    pl: "Email",
    en: "Email",
    uk: "Email",
    ru: "Email"
  },
  formPhone: {
    pl: "Telefon (opcjonalnie)",
    en: "Phone (optional)",
    uk: "Телефон (опціонально)",
    ru: "Телефон (опционально)"
  },
  formServiceSelection: {
    pl: "Wybór usługi",
    en: "Service selection",
    uk: "Вибір послуги",
    ru: "Выбор услуги"
  },
  formService: {
    pl: "Wybrana usługa",
    en: "Selected service",
    uk: "Обрана послуга",
    ru: "Выбранная услуга"
  },
  formMessage: {
    pl: "Twoja wiadomość (opcjonalnie)",
    en: "Your message (optional)",
    uk: "Ваше повідомлення (опціонально)",
    ru: "Ваше сообщение (опционально)"
  },
  formConsultationAbout: {
    pl: "Czego dotyczy konsultacja? (opcjonalnie)",
    en: "What is the consultation about? (optional)",
    uk: "Про що консультація? (опціонально)",
    ru: "О чем консультация? (опционально)"
  },
  formPlaceholderName: {
    pl: "Wprowadź swoje imię",
    en: "Enter your name",
    uk: "Введіть своє ім'я",
    ru: "Введите свое имя"
  },
  formPlaceholderEmail: {
    pl: "twoj@email.com",
    en: "your@email.com",
    uk: "твоя@пошта.com",
    ru: "твоя@почта.com"
  },
  formPlaceholderPhone: {
    pl: "+48 123 456 789",
    en: "+48 123 456 789",
    uk: "+48 123 456 789",
    ru: "+48 123 456 789"
  },
  formPlaceholderMessage: {
    pl: "Opisz swoją sprawę...",
    en: "Describe your case...",
    uk: "Опишіть свою справу...",
    ru: "Опишите свое дело..."
  },
  formSubmitInquiry: {
    pl: "Wyślij zapytanie",
    en: "Send inquiry",
    uk: "Надіслати запит",
    ru: "Отправить запрос"
  },
  formBookConsultation: {
    pl: "Umów konsultację",
    en: "Book consultation",
    uk: "Записатися на консультацію",
    ru: "Записаться на консультацию"
  },
  formPreferredDate: {
    pl: "Preferowana data (opcjonalnie)",
    en: "Preferred date (optional)",
    uk: "Бажана дата (опціонально)",
    ru: "Предпочтительная дата (опционально)"
  },
  formPreferredTime: {
    pl: "Preferowana pora (opcjonalnie)",
    en: "Preferred time (optional)",
    uk: "Бажаний час (опціонально)",
    ru: "Предпочтительное время (опционально)"
  },
  formSelectTimeOfDay: {
    pl: "Wybierz porę dnia",
    en: "Select time of day",
    uk: "Виберіть час дня",
    ru: "Выберите время дня"
  },
  formDataProtection: {
    pl: "Dane są chronione zgodnie z polityką prywatności",
    en: "Data is protected in accordance with the privacy policy",
    uk: "Дані захищені відповідно до політики конфіденційності",
    ru: "Данные защищены в соответствии с политикой конфиденциальности"
  },
  sendMessage: {
    pl: "Wyślij wiadomość",
    en: "Send message",
    uk: "Надіслати повідомлення",
    ru: "Отправить сообщение"
  },

  // Notifications
  notificationSuccess: {
    pl: "Dziękujemy, skontaktujemy się wkrótce!",
    en: "Thank you, we will contact you soon!",
    uk: "Дякуємо, ми зв'яжемося з вами найближчим часом!",
    ru: "Спасибо, мы свяжемся с вами в ближайшее время!"
  },
  
  // Contact Page Additional Sections
  address: {
    pl: "Adres",
    en: "Address",
    uk: "Адреса",
    ru: "Адрес"
  },
  phone: {
    pl: "Telefon",
    en: "Phone",
    uk: "Телефон",
    ru: "Телефон"
  },
  openingHours: {
    pl: "Godziny otwarcia",
    en: "Opening hours",
    uk: "Години роботи",
    ru: "Часы работы"
  },
  workingDays: {
    pl: "Poniedziałek - Piątek: 9:00 - 17:00",
    en: "Monday - Friday: 9:00 - 17:00",
    uk: "Понеділок - П'ятниця: 9:00 - 17:00",
    ru: "Понедельник - Пятница: 9:00 - 17:00"
  },
  weekends: {
    pl: "Sobota - Niedziela: Zamknięte",
    en: "Saturday - Sunday: Closed",
    uk: "Субота - Неділя: Зачинено",
    ru: "Суббота - Воскресенье: Закрыто"
  },
  ourLocation: {
    pl: "Nasza lokalizacja",
    en: "Our location",
    uk: "Наше розташування",
    ru: "Наше местоположение"
  },

  // Footer Notes
  noteVAT: {
    pl: "* Wszystkie ceny są cenami netto i należy do nich doliczyć podatek VAT w wysokości 23%.",
    en: "* All prices are net prices and are subject to 23% VAT.",
    uk: "* Усі ціни вказані без ПДВ, до них слід додати 23% ПДВ.",
    ru: "* Все цены указаны без НДС, к ним следует добавить 23% НДС."
  },
  noteFinalPrice: {
    pl: "* Ostateczna cena może się różnić w zależności od złożoności sprawy i zakresu usług.",
    en: "* The final price may vary depending on the complexity of the case and the scope of services.",
    uk: "* Остаточна ціна може відрізнятися залежно від складності справи та обсягу послуг.",
    ru: "* Окончательная цена может отличаться в зависимости от сложности дела и объема услуг."
  },

  // Validation Messages
  validationNameRequired: {
    pl: "Imię jest wymagane",
    en: "Name is required",
    uk: "Ім'я обов'язкове",
    ru: "Имя обязательно"
  },
  validationEmailInvalid: {
    pl: "Nieprawidłowy adres email",
    en: "Invalid email address",
    uk: "Неправильна адреса електронної пошти",
    ru: "Неправильный адрес электронной почты"
  },
  validationMessageRequired: {
    pl: "Wiadomość musi zawierać co najmniej 10 znaków",
    en: "Message must be at least 10 characters",
    uk: "Повідомлення має містити щонайменше 10 символів",
    ru: "Сообщение должно содержать не менее 10 символов"
  },
  validationServiceRequired: {
    pl: "Wybierz usługę",
    en: "Select a service",
    uk: "Виберіть послугу",
    ru: "Выберите услугу"
  },
  
  // Service Translations for Contact Form
  serviceCompanyRegistration: {
    pl: "Rejestracja spółki",
    en: "Company registration",
    uk: "Реєстрація компанії",
    ru: "Регистрация компании"
  },
  serviceKRSChanges: {
    pl: "Zmiany w KRS",
    en: "KRS changes",
    uk: "Зміни в KRS",
    ru: "Изменения в KRS"
  },
  serviceVirtualAddress: {
    pl: "Adres wirtualny",
    en: "Virtual address",
    uk: "Віртуальна адреса",
    ru: "Виртуальный адрес"
  },
  serviceCarRegistrationEU: {
    pl: "Rejestracja auta z UE",
    en: "Car registration from EU",
    uk: "Реєстрація автомобіля з ЄС",
    ru: "Регистрация автомобиля из ЕС"
  },
  serviceCarRegistrationNonEU: {
    pl: "Rejestracja auta spoza UE",
    en: "Car registration from outside EU",
    uk: "Реєстрація автомобіля з-поза меж ЄС",
    ru: "Регистрация автомобиля из-за пределов ЕС"
  },
  serviceCarInsurance: {
    pl: "Ubezpieczenie pojazdu",
    en: "Vehicle insurance",
    uk: "Страхування транспортного засобу",
    ru: "Страхование транспортного средства"
  },
  serviceResidencePermit: {
    pl: "Legalizacja pobytu",
    en: "Residence permit",
    uk: "Легалізація перебування",
    ru: "Легализация пребывания"
  },
  servicePESELNumber: {
    pl: "Uzyskanie numeru PESEL",
    en: "Obtaining PESEL number",
    uk: "Отримання номера PESEL",
    ru: "Получение номера PESEL"
  },
  serviceAccountingBasic: {
    pl: "Księgowość - pakiet podstawowy",
    en: "Accounting - basic package",
    uk: "Бухгалтерія - базовий пакет",
    ru: "Бухгалтерия - базовый пакет"
  },
  serviceAccountingStandard: {
    pl: "Księgowość - pakiet standard",
    en: "Accounting - standard package",
    uk: "Бухгалтерія - стандартний пакет",
    ru: "Бухгалтерия - стандартный пакет"
  },
  serviceAccountingPremium: {
    pl: "Księgowość - pakiet premium",
    en: "Accounting - premium package",
    uk: "Бухгалтерія - преміум пакет",
    ru: "Бухгалтерия - премиум пакет"
  },
  serviceOther: {
    pl: "Inne",
    en: "Other",
    uk: "Інше",
    ru: "Другое"
  },
  
  // Services Section Cards
  businessServices: {
    pl: "Usługi dla firm",
    en: "Business services",
    uk: "Послуги для бізнесу",
    ru: "Услуги для бизнеса"
  },
  businessServicesDesc: {
    pl: "Wspieramy rozwój Twojego biznesu poprzez profesjonalną obsługę prawną, rejestrację spółek oraz doradztwo w zakresie prowadzenia działalności.",
    en: "We support the development of your business through professional legal services, company registration, and business consulting.",
    uk: "Ми підтримуємо розвиток вашого бізнесу через професійні юридичні послуги, реєстрацію компаній та консультації з ведення бізнесу.",
    ru: "Мы поддерживаем развитие вашего бизнеса через профессиональные юридические услуги, регистрацию компаний и консультации по ведению бизнеса."
  },
  companyRegistration: {
    pl: "Rejestracja spółek",
    en: "Company registration",
    uk: "Реєстрація компаній",
    ru: "Регистрация компаний"
  },
  krsChanges: {
    pl: "Zmiany w KRS",
    en: "KRS changes",
    uk: "Зміни в KRS",
    ru: "Изменения в KRS"
  },
  virtualAddress: {
    pl: "Adres wirtualny",
    en: "Virtual address",
    uk: "Віртуальна адреса",
    ru: "Виртуальный адрес"
  },
  vehicleRegistration: {
    pl: "Rejestracja pojazdów",
    en: "Vehicle registration",
    uk: "Реєстрація транспортних засобів",
    ru: "Регистрация транспортных средств"
  },
  vehicleRegistrationDesc: {
    pl: "Kompleksowa obsługa w zakresie rejestracji i ubezpieczenia pojazdów z Polski i zagranicy. Oszczędzamy Twój czas i formalnościach.",
    en: "Comprehensive service in the registration and insurance of vehicles from Poland and abroad. We save your time and formalities.",
    uk: "Комплексне обслуговування з реєстрації та страхування транспортних засобів з Польщі та з-за кордону. Економимо ваш час на формальностях.",
    ru: "Комплексное обслуживание по регистрации и страхованию транспортных средств из Польши и из-за рубежа. Экономим ваше время на формальностях."
  },
  euCarRegistration: {
    pl: "Rejestracja aut z UE",
    en: "EU car registration",
    uk: "Реєстрація авто з ЄС",
    ru: "Регистрация авто из ЕС"
  },
  nonEuCarRegistration: {
    pl: "Rejestracja aut spoza UE",
    en: "Non-EU car registration",
    uk: "Реєстрація авто з-за меж ЄС",
    ru: "Регистрация авто из-за пределов ЕС"
  },
  insurance: {
    pl: "Ubezpieczenia",
    en: "Insurance",
    uk: "Страхування",
    ru: "Страхование"
  },
  residencePermit: {
    pl: "Legalizacja pobytu",
    en: "Residence permit",
    uk: "Легалізація перебування",
    ru: "Легализация пребывания"
  },
  residencePermitDesc: {
    pl: "Pomagamy w sprawach związanych z legalizacją pobytu cudzoziemców w Polsce. Oferujemy wsparcie w uzyskaniu niezbędnych dokumentów.",
    en: "We help with matters related to legalizing the stay of foreigners in Poland. We offer support in obtaining the necessary documents.",
    uk: "Ми допомагаємо з питаннями, пов'язаними з легалізацією перебування іноземців у Польщі. Пропонуємо підтримку в отриманні необхідних документів.",
    ru: "Мы помогаем с вопросами, связанными с легализацией пребывания иностранцев в Польше. Предлагаем поддержку в получении необходимых документов."
  },
  legalizeResidence: {
    pl: "Legalizacja pobytu",
    en: "Residence legalization",
    uk: "Легалізація перебування",
    ru: "Легализация пребывания"
  },
  obtainPesel: {
    pl: "Uzyskanie PESEL",
    en: "Obtaining PESEL",
    uk: "Отримання PESEL",
    ru: "Получение PESEL"
  },
  representationBeforeOffices: {
    pl: "Reprezentacja przed urzędami",
    en: "Representation before offices",
    uk: "Представництво перед органами влади",
    ru: "Представительство перед органами власти"
  },
  accountingTax: {
    pl: "Księgowość / Tax",
    en: "Accounting / Tax",
    uk: "Бухгалтерія / Tax",
    ru: "Бухгалтерия / Tax"
  },
  accountingTaxDesc: {
    pl: "Zapewniamy profesjonalną obsługę księgową dopasowaną do potrzeb Twojej firmy. Oferujemy różne pakiety usług księgowych.",
    en: "We provide professional accounting services tailored to the needs of your company. We offer various accounting service packages.",
    uk: "Ми забезпечуємо професійні бухгалтерські послуги, адаптовані до потреб вашої компанії. Пропонуємо різноманітні пакети бухгалтерських послуг.",
    ru: "Мы обеспечиваем профессиональные бухгалтерские услуги, адаптированные к потребностям вашей компании. Предлагаем различные пакеты бухгалтерских услуг."
  },
  basicPackage: {
    pl: "Pakiet podstawowy",
    en: "Basic package",
    uk: "Базовий пакет",
    ru: "Базовый пакет"
  },
  standardPackage: {
    pl: "Pakiet standard",
    en: "Standard package",
    uk: "Стандартний пакет",
    ru: "Стандартный пакет"
  },
  premiumPackage: {
    pl: "Pakiet premium",
    en: "Premium package",
    uk: "Преміум пакет",
    ru: "Премиум пакет"
  },

  // Header Translations
  freeConsultation: {
    pl: "Bezpłatna konsultacja",
    en: "Free consultation",
    uk: "Безкоштовна консультація",
    ru: "Бесплатная консультация"
  },
  bookConsultation: {
    pl: "Umów konsultację",
    en: "Book consultation",
    uk: "Записатися на консультацію",
    ru: "Записаться на консультацию"
  },
  menu: {
    pl: "Menu",
    en: "Menu",
    uk: "Меню",
    ru: "Меню"
  },
  languageSwitchLabel: {
    pl: "Język / Language:",
    en: "Language / Język:",
    uk: "Мова / Language:",
    ru: "Язык / Language:"
  },
  changeLanguage: {
    pl: "Zmień język",
    en: "Change language",
    uk: "Змінити мову",
    ru: "Изменить язык"
  },

  // Labels
  labelRecommended: {
    pl: "Polecany",
    en: "Recommended",
    uk: "Рекомендований",
    ru: "Рекомендуемый"
  },
  
  // Our Values Section
  ourValues: {
    pl: "Nasze wartości",
    en: "Our values",
    uk: "Наші цінності",
    ru: "Наши ценности"
  },
  professionalismAndExperience: {
    pl: "Profesjonalizm i doświadczenie",
    en: "Professionalism and experience",
    uk: "Професіоналізм і досвід",
    ru: "Профессионализм и опыт"
  },
  professionalismDescription: {
    pl: "Nasz zespół składa się z wykwalifikowanych specjalistów, którzy posiadają wieloletnie doświadczenie w obsłudze klientów biznesowych i indywidualnych.",
    en: "Our team consists of qualified specialists who have many years of experience in serving business and individual clients.",
    uk: "Наша команда складається з кваліфікованих спеціалістів, які мають багаторічний досвід обслуговування бізнес-клієнтів та приватних осіб.",
    ru: "Наша команда состоит из квалифицированных специалистов, имеющих многолетний опыт обслуживания бизнес-клиентов и частных лиц."
  },
  knowledgeBackedByPractice: {
    pl: "Wiedza poparta praktyką",
    en: "Knowledge backed by practice",
    uk: "Знання, підкріплені практикою",
    ru: "Знания, подкрепленные практикой"
  },
  knowledgeOfCurrentRegulations: {
    pl: "Znajomość aktualnych przepisów",
    en: "Knowledge of current regulations",
    uk: "Знання актуальних нормативних актів",
    ru: "Знание актуальных нормативных актов"
  },
  continuousSkillImprovement: {
    pl: "Stałe podnoszenie kwalifikacji",
    en: "Continuous skill improvement",
    uk: "Постійне підвищення кваліфікації",
    ru: "Постоянное повышение квалификации"
  },
  cooperationWithIndustryExperts: {
    pl: "Współpraca z ekspertami branżowymi",
    en: "Cooperation with industry experts",
    uk: "Співпраця з галузевими експертами",
    ru: "Сотрудничество с отраслевыми экспертами"
  },

  individualApproach: {
    pl: "Indywidualne podejście",
    en: "Individual approach",
    uk: "Індивідуальний підхід",
    ru: "Индивидуальный подход"
  },
  individualApproachDescription: {
    pl: "Każdą sprawę traktujemy indywidualnie, dostosowując nasze rozwiązania do unikalnych potrzeb i oczekiwań klienta.",
    en: "We treat each case individually, adapting our solutions to the unique needs and expectations of the client.",
    uk: "Ми розглядаємо кожну справу індивідуально, адаптуючи наші рішення до унікальних потреб і очікувань клієнта.",
    ru: "Мы рассматриваем каждое дело индивидуально, адаптируя наши решения к уникальным потребностям и ожиданиям клиента."
  },
  dedicatedCustomerService: {
    pl: "Dedykowany opiekun klienta",
    en: "Dedicated customer service",
    uk: "Персональний менеджер клієнта",
    ru: "Персональный менеджер клиента"
  },
  flexibleSolutions: {
    pl: "Elastyczne rozwiązania",
    en: "Flexible solutions",
    uk: "Гнучкі рішення",
    ru: "Гибкие решения"
  },
  offerCustomization: {
    pl: "Dostosowanie oferty do potrzeb",
    en: "Customization of the offer to needs",
    uk: "Адаптація пропозиції до потреб",
    ru: "Адаптация предложения к потребностям"
  },
  constantCommunicationAndFeedback: {
    pl: "Stała komunikacja i feedback",
    en: "Constant communication and feedback",
    uk: "Постійна комунікація та зворотній зв'язок",
    ru: "Постоянная коммуникация и обратная связь"
  },
  solutionsTailoredToNeeds: {
    pl: "Rozwiązania dopasowane do potrzeb",
    en: "Solutions tailored to needs",
    uk: "Рішення, адаптовані до потреб",
    ru: "Решения, адаптированные к потребностям"
  },
  solutionsTailoredDescription: {
    pl: "Każdy klient i każda sprawa są wyjątkowe. Dlatego nie stosujemy standardowych rozwiązań, lecz dopasowujemy nasze usługi do indywidualnych wymagań i oczekiwań.",
    en: "Each client and each case are unique. That's why we don't apply standard solutions, but tailor our services to individual requirements and expectations.",
    uk: "Кожен клієнт і кожна справа є унікальними. Тому ми не застосовуємо стандартні рішення, а адаптуємо наші послуги до індивідуальних вимог та очікувань.",
    ru: "Каждый клиент и каждое дело уникальны. Поэтому мы не применяем стандартные решения, а адаптируем наши услуги к индивидуальным требованиям и ожиданиям."
  },
  operationalEfficiency: {
    pl: "Efektywność działania",
    en: "Operational efficiency",
    uk: "Ефективність діяльності",
    ru: "Эффективность деятельности"
  },
  operationalEfficiencyDescription: {
    pl: "Realizujemy zlecenia sprawnie i skutecznie, oszczędzając Twój czas i minimalizując formalności, z którymi musisz się zmierzyć.",
    en: "We execute orders efficiently and effectively, saving your time and minimizing the formalities you have to deal with.",
    uk: "Ми виконуємо замовлення ефективно і результативно, економлячи ваш час та мінімізуючи формальності, з якими вам доводиться стикатися.",
    ru: "Мы выполняем заказы эффективно и результативно, экономя ваше время и минимизируя формальности, с которыми вам приходится сталкиваться."
  },
  fastOrderExecution: {
    pl: "Szybka realizacja zleceń",
    en: "Fast order execution",
    uk: "Швидке виконання замовлень",
    ru: "Быстрое выполнение заказов"
  },
  meetingDeadlines: {
    pl: "Dotrzymywanie terminów",
    en: "Meeting deadlines",
    uk: "Дотримання термінів",
    ru: "Соблюдение сроков"
  },
  processOptimization: {
    pl: "Optymalizacja procesów",
    en: "Process optimization",
    uk: "Оптимізація процесів",
    ru: "Оптимизация процессов"
  },
  formalitiesMinimization: {
    pl: "Minimalizacja formalności",
    en: "Minimization of formalities",
    uk: "Мінімізація формальностей",
    ru: "Минимизация формальностей"
  },
  efficientHandlingOfEachOrder: {
    pl: "Sprawna realizacja każdego zlecenia",
    en: "Efficient handling of each order",
    uk: "Ефективне виконання кожного замовлення",
    ru: "Эффективное выполнение каждого заказа"
  },
  efficientHandlingDescription: {
    pl: "Wiemy, jak cenny jest czas naszych klientów. Dlatego wszystkie sprawy realizujemy sprawnie i skutecznie, bez zbędnych opóźnień i formalności.",
    en: "We know how valuable our clients' time is. That's why we handle all matters efficiently and effectively, without unnecessary delays and formalities.",
    uk: "Ми знаємо, наскільки цінним є час наших клієнтів. Тому ми виконуємо всі справи ефективно і результативно, без зайвих затримок і формальностей.",
    ru: "Мы знаем, насколько ценно время наших клиентов. Поэтому мы выполняем все дела эффективно и результативно, без лишних задержек и формальностей."
  },
  
  // Services Page Translations
  servicesPageTitle: {
    pl: "Nasze Usługi",
    en: "Our Services",
    uk: "Послуги",
    ru: "Наши Услуги"
  },
  servicesPageDescription: {
    pl: "Oferujemy kompleksowe wsparcie dla firm i osób prywatnych. Wybierz kategorię, aby poznać szczegółowy zakres naszych usług.",
    en: "We offer comprehensive support for businesses and individuals. Choose a category to learn about the detailed scope of our services.",
    uk: "Ми пропонуємо комплексну підтримку для компаній та приватних осіб. Виберіть категорію, щоб дізнатися про детальний обсяг наших послуг.",
    ru: "Мы предлагаем комплексную поддержку для компаний и частных лиц. Выберите категорию, чтобы узнать о детальном объеме наших услуг."
  },
  servicesCompanyTabTitle: {
    pl: "Usługi dla firm",
    en: "Company Services",
    uk: "Послуги для компаній",
    ru: "Услуги для компаний"
  },
  servicesAutoTabTitle: {
    pl: "Usługi motoryzacyjne",
    en: "Automotive Services",
    uk: "Автомобільні послуги",
    ru: "Автомобильные услуги"
  },
  servicesSupportTabTitle: {
    pl: "Wsparcie prawne i administracyjne",
    en: "Legal and Administrative Support",
    uk: "Юридична та адміністративна підтримка",
    ru: "Юридическая и административная поддержка"
  },
  servicesTaxTabTitle: {
    pl: "Usługi księgowe",
    en: "Accounting Services",
    uk: "Бухгалтерські послуги",
    ru: "Бухгалтерские услуги"
  },
  servicesAskForDetails: {
    pl: "Zapytaj o szczegóły",
    en: "Ask for details",
    uk: "Запитати про деталі",
    ru: "Спросить о деталях"
  },
  servicesNotFound: {
    pl: "Nie znalazłeś tego, czego szukasz?",
    en: "Didn't find what you're looking for?",
    uk: "Не знайшли те, що шукаєте?",
    ru: "Не нашли то, что ищете?"
  },
  servicesFlexibleOffer: {
    pl: "Nasza oferta jest elastyczna i dostosowana do indywidualnych potrzeb. Skontaktuj się z nami, aby omówić Twoją sytuację.",
    en: "Our offer is flexible and tailored to individual needs. Contact us to discuss your situation.",
    uk: "Наша пропозиція є гнучкою і адаптованою до індивідуальних потреб. Зв'яжіться з нами, щоб обговорити вашу ситуацію.",
    ru: "Наше предложение гибкое и адаптировано к индивидуальным потребностям. Свяжитесь с нами, чтобы обсудить вашу ситуацию."
  },
  servicesContactUs: {
    pl: "Skontaktuj się z nami",
    en: "Contact us",
    uk: "Зв'яжіться з нами",
    ru: "Свяжитесь с нами"
  },
  servicesInquiryTitle: {
    pl: "Zapytanie o usługę",
    en: "Service inquiry",
    uk: "Запит про послугу",
    ru: "Запрос об услуге"
  },
  
  // Company Services
  companyServiceRegisterCompany: {
    pl: "Rejestracja sp. z o.o., JDG, spółka komandytowa",
    en: "Registration of LLC, sole proprietorship, limited partnership",
    uk: "Реєстрація ТОВ, ФОП, командитного товариства",
    ru: "Регистрация ООО, ИП, коммандитного товарищества"
  },
  companyServiceRegisterDesc: {
    pl: "Kompleksowa usługa rejestracji spółek z o.o., jednoosobowej działalności gospodarczej oraz spółek komandytowych. Zajmujemy się całym procesem - od wyboru optymalnej formy prawnej, przygotowania wszystkich dokumentów, po złożenie wniosku w urzędzie. Oferujemy rejestrację przez system S24 (24-48h) lub tradycyjną u notariusza. Zapewniamy doradztwo w zakresie wyboru formy opodatkowania, kodów PKD oraz optymalizacji struktury firmy. Nasi eksperci pomogą również w dopełnieniu formalności związanych z ZUS, US oraz uzyskaniem niezbędnych numerów identyfikacyjnych.",
    en: "We establish companies quickly and comprehensively. We prepare all necessary documents, represent you in offices, and provide advice on choosing the best form of business activity.",
    uk: "Ми швидко та комплексно створюємо компанії. Ми готуємо всі необхідні документи, представляємо вас в органах влади та надаємо поради щодо вибору найкращої форми діяльності.",
    ru: "Мы быстро и комплексно создаем компании. Мы подготавливаем все необходимые документы, представляем вас в органах власти и предоставляем советы по выбору лучшей формы деятельности."
  },
  companyServiceKRSChangesTitle: {
    pl: "Zmiany w KRS",
    en: "Changes in KRS",
    uk: "Зміни в KRS",
    ru: "Изменения в KRS"
  },
  companyServiceKRSDesc: {
    pl: "Profesjonalna obsługa w zakresie zmian w Krajowym Rejestrze Sądowym. Nasza usługa obejmuje kompleksowe wsparcie przy wprowadzaniu modyfikacji do rejestru, przygotowanie wszystkich niezbędnych dokumentów oraz reprezentację przed sądem. Pomagamy w przeprowadzeniu zmian w składzie zarządu i rady nadzorczej, zmianie siedziby firmy, aktualizacji kodów PKD (Polskiej Klasyfikacji Działalności), zmianie nazwy spółki, modyfikacji wysokości kapitału zakładowego oraz struktury udziałowej, a także we wszystkich innych zmianach wymagających aktualizacji w KRS. Dzięki naszemu doświadczeniu proces wprowadzania zmian przebiega sprawnie i bez błędów formalnych.",
    en: "We update your company data in the National Court Register. We help with changes in management, address, PKD codes, and all other elements that require updating.",
    uk: "Ми оновлюємо дані вашої компанії в Національному судовому реєстрі (KRS). Наша послуга включає комплексну підтримку при внесенні змін до реєстру, підготовку всіх необхідних документів та представництво в суді. Ми допомагаємо зі змінами в складі правління, зміною юридичної адреси, зміною статутного капіталу, оновленням кодів PKD (видів діяльності), зміною назви компанії та іншими змінами, які вимагають оновлення в реєстрі. Завдяки нашій допомозі процес внесення змін відбувається швидко та без помилок.",
    ru: "Мы обновляем данные вашей компании в Национальном судебном реестре. Мы помогаем с изменени��ми в руководстве, адресе, кодах PKD и всех других элементах, требующих обновления."
  },
  companyServiceFinancingTitle: {
    pl: "Finansowanie i dotacje",
    en: "Financing and grants",
    uk: "Фінансування та гранти",
    ru: "Финансирование и гранты"
  },
  companyServiceFinancingDesc: {
    pl: "Pomagamy w uzyskaniu finansowania dla Twojej firmy. Przygotowujemy wnioski o dotacje, pożyczki oraz inne formy wsparcia finansowego.",
    en: "We help obtain financing for your company. We prepare applications for grants, loans, and other forms of financial support.",
    uk: "Ми надаємо комплексну підтримку у пошуку та отриманні фінансування для розвитку вашого бізнесу. Наші фахівці допомагають з підготовкою повного пакету документів для отримання грантів від ЄС, державних дотацій, пільгових кредитів та інвестицій. Ми аналізуємо потреби вашого бізнесу, підбираємо оптимальні програми фінансування, готуємо бізнес-плани та фінансові прогнози, складаємо заявки на отримання коштів, супроводжуємо проект на всіх етапах фінансування та звітуємо перед фінансовими установами. Наша мета – забезпечити вашій компанії доступ до найвигідніших фінансових інструментів для стабільного зростання.",
    ru: "Мы помогаем получить финансирование для вашей компании. Мы подготавливаем заявки на гранты, займы и другие формы финансовой поддержки."
  },
  companyServiceVirtualAddressTitle: {
    pl: "Adres wirtualny",
    en: "Virtual address",
    uk: "Віртуальна адреса",
    ru: "Виртуальный адрес"
  },
  companyServiceVirtualAddressDesc: {
    pl: "Oferujemy prestiżowy adres wirtualny dla Twojej firmy w centrum biznesowym Poznania, co znacząco podnosi wizerunek Twojego przedsiębiorstwa. Nasza usługa obejmuje rejestrację firmy pod naszym adresem, odbiór całej korespondencji, skanowanie i przesyłanie dokumentów drogą elektroniczną, dostęp do indywidualnego panelu online z archiwum wszystkich dokumentów oraz możliwość wykorzystania adresu na wizytówkach i materiałach marketingowych. Dodatkowo zapewniamy: przekierowanie korespondencji na wskazany adres, powiadomienia o ważnych listach i przesyłkach urzędowych, przechowywanie oryginałów dokumentów oraz bezpieczne niszczenie niepotrzebnych materiałów. Adres wirtualny to idealne rozwiązanie dla przedsiębiorców pracujących zdalnie lub z domu, dla startupów oraz firm zagranicznych wchodzących na polski rynek.",
    en: "We offer a professional address for your company in the center of Poznań. We receive and scan correspondence, providing online access to all documents.",
    uk: "Ми пропонуємо престижну віртуальну адресу для вашої компанії в діловому центрі Познані, що значно покращує імідж вашого бізнесу. Наша послуга включає реєстрацію компанії за нашою адресою, отримання всієї кореспонденції, сканування та пересилання документів електронною поштою, доступ до персонального онлайн-кабінету з архівом усіх документів, можливість використання адреси на візитках та рекламних матеріалах. Ми також пропонуємо додаткові послуги: переадресацію кореспонденції, повідомлення про важливі листи, зберігання оригіналів документів та конфіденційне знищення непотрібних документів. Віртуальна адреса - це ідеальне рішення для підприємців, які працюють віддалено або з дому, для стартапів та іноземних компаній, що виходять на польський ринок.",
    ru: "Мы предлагаем профессиональный адрес для вашей компании в центре Познани. Мы получаем и сканируем корреспонденцию, обеспечивая онлайн-доступ ко всем документам."
  },
  
  // Auto Services
  autoServiceRegisterEUTitle: {
    pl: "Rejestracja aut z UE",
    en: "Registration of cars from the EU",
    uk: "Реєстрація автомобілів з ЄС",
    ru: "Регистрация автомобилей из ЕС"
  },
  autoServiceRegisterEUDesc: {
    pl: "Kompleksowa i szybka rejestracja pojazdów sprowadzonych z krajów Unii Europejskiej. Zajmujemy się przygotowaniem wszystkich dokumentów i reprezentacją w urzędach.",
    en: "Comprehensive and fast registration of vehicles imported from European Union countries. We prepare all documents and represent you in offices.",
    uk: "Комплексна та швидка реєстрація транспортних засобів, імпортованих з країн Європейського Союзу. Ми готуємо всі документи та представляємо вас в органах влади.",
    ru: "Комплексная и быстрая регистрация транспортных средств, импортированных из стран Европейского Союза. Мы подготавливаем все документы и представляем вас в органах власти."
  },
  autoServiceRegisterNonEUTitle: {
    pl: "Rejestracja aut spoza UE",
    en: "Registration of cars from outside the EU",
    uk: "Реєстрація автомобілів з-за меж ЄС",
    ru: "Регистрация автомобилей из-за пределов ЕС"
  },
  autoServiceRegisterNonEUDesc: {
    pl: "Profesjonalne wsparcie w procesie rejestracji pojazdów sprowadzonych spoza Unii Europejskiej, wraz z pomocą w przejściu przez procedury celne.",
    en: "Professional support in the process of registering vehicles imported from outside the European Union, along with assistance in going through customs procedures.",
    uk: "Професійна підтримка в процесі реєстрації транспортних засобів, імпортованих з-за меж Європейського Союзу, а також допомога в проходженні митних процедур.",
    ru: "Профессиональная поддержка в процессе регистрации транспортных средств, импортированных из-за пределов Европейского Союза, а также помощь в прохождении таможенных процедур."
  },
  autoServiceInsuranceTitle: {
    pl: "Ubezpieczenia komunikacyjne",
    en: "Motor insurance",
    uk: "Автострахування",
    ru: "Автострахование"
  },
  autoServiceInsuranceDesc: {
    pl: "Oferujemy konkurencyjne stawki ubezpieczeń OC, AC, NNW i Assistance dla Twojego pojazdu. Pomagamy wybrać najlepszą ofertę dostosowaną do Twoich potrzeb.",
    en: "We offer competitive rates for liability insurance, comprehensive insurance, accident insurance, and Assistance for your vehicle. We help you choose the best offer tailored to your needs.",
    uk: "Ми пропонуємо конкурентні ставки для страхування відповідальності, повного страхування, страхування від нещасних випадків і Assistance для вашого транспортного засобу. Ми допомагаємо вам вибрати найкращу пропозицію, адаптовану до ваших потреб.",
    ru: "Мы предлагаем конкурентные ставки для страхования ответственности, полного страхования, страхования от несчастных случаев и Assistance для вашего транспортного средства. Мы помогаем вам выбрать лучшее предложение, адаптированное к вашим потребностям."
  },
  autoServiceTechnicalTitle: {
    pl: "Badania techniczne i wyrejestrowanie",
    en: "Technical inspections and deregistration",
    uk: "Технічні огляди та зняття з обліку",
    ru: "Технические осмотры и снятие с учета"
  },
  autoServiceTechnicalDesc: {
    pl: "Kompleksowa obsługa w zakresie badań technicznych oraz formalności związanych z wyrejestrowaniem pojazdu.",
    en: "Comprehensive service in the field of technical inspections and formalities related to vehicle deregistration.",
    uk: "Комплексне обслуговування у сфері технічних оглядів та формальностей, пов'язаних зі зняттям транспортного засобу з обліку.",
    ru: "Комплексное обслуживание в сфере технических осмотров и формальностей, связанных со снятием транспортного средства с учета."
  },
  
  // Support Services
  supportServiceLegalizationTitle: {
    pl: "Legalizacja pobytu",
    en: "Residence legalization",
    uk: "Легалізація перебування",
    ru: "Легализация пребывания"
  },
  supportServiceLegalizationDesc: {
    pl: "Kompleksowa pomoc w uzyskaniu karty pobytu czasowego i stałego, wizy oraz innych dokumentów legalizujących pobyt w Polsce. Oferujemy wsparcie na każdym etapie procedury, przygotowanie wniosków i dokumentów, reprezentację przed urzędami oraz doradztwo w zakresie najkorzystniejszych ścieżek legalizacji pobytu. Nasi specjaliści posiadają bogate doświadczenie w przeprowadzaniu cudzoziemców przez procedury legalizacyjne, co pozwala uniknąć typowych błędów i przyspieszyć cały proces.",
    en: "Comprehensive assistance in obtaining a temporary and permanent residence card, visa, and other documents legalizing stay in Poland. Support at every stage of the procedure.",
    uk: "Комплексна допомога в отриманні карти тимчасового та постійного перебування, візи та інших документів, що легалізують перебування в Польщі. Підтримка на кожному етапі процедури.",
    ru: "Комплексная помощь в получении карты временного и постоянного пребывания, визы и других документов, легализующих пребывание в Польше. Поддержка на каждом этапе процедуры."
  },
  supportServicePESELTitle: {
    pl: "Uzyskanie numeru PESEL",
    en: "Obtaining a PESEL number",
    uk: "Отримання номера PESEL",
    ru: "Получение номера PESEL"
  },
  supportServicePESELDesc: {
    pl: "Profesjonalne wsparcie w procesie uzyskania numeru PESEL, niezbędnego do funkcjonowania w polskim systemie administracyjnym i prawnym. Pomagamy w przygotowaniu niezbędnych dokumentów, wypełnieniu wniosków oraz reprezentujemy klientów w urzędach. Numer PESEL jest kluczowy dla cudzoziemców przebywających w Polsce, umożliwia korzystanie z opieki zdrowotnej, założenie konta bankowego, podpisanie umowy o pracę i załatwianie innych spraw urzędowych.",
    en: "Professional support in the process of obtaining a PESEL number, necessary for functioning in the Polish administrative and legal system.",
    uk: "Професійна підтримка в процесі отримання номера PESEL, необхідного для функціонування в польській адміністративній та правовій системі.",
    ru: "Профессиональная поддержка в процессе получения номера PESEL, необходимого для функционирования в польской административной и правовой системе."
  },
  supportServiceRepresentationTitle: {
    pl: "Reprezentacja przed urzędami",
    en: "Representation before offices",
    uk: "Представництво перед органами влади",
    ru: "Представительство перед органами власти"
  },
  supportServiceRepresentationDesc: {
    pl: "Reprezentujemy klientów przed urzędami i instytucjami, dbając o ich interesy i zapewniając profesjonalną obsługę spraw administracyjnych. Nasi specjaliści posiadają wieloletnie doświadczenie w reprezentowaniu klientów przed urzędami wojewódzkimi, urzędami miasta, ZUS-em, urzędami skarbowymi i innymi instytucjami. Dzięki doskonałej znajomości procedur administracyjnych i dobrym relacjom z urzędnikami jesteśmy w stanie skutecznie załatwiać nawet najbardziej skomplikowane sprawy, oszczędzając naszym klientom czas i stres.",
    en: "We represent clients before offices and institutions, taking care of their interests and providing professional handling of administrative matters.",
    uk: "Ми представляємо клієнтів перед органами влади та установами, дбаючи про їхні інтереси та забезпечуючи професійне ведення адміністративних справ.",
    ru: "Мы представляем клиентов перед органами власти и учреждениями, заботясь об их интересах и обеспечивая профессиональное ведение административных дел."
  },
  supportServiceTranslationTitle: {
    pl: "Tłumaczenia przysięgłe",
    en: "Certified translations",
    uk: "Присяжні переклади",
    ru: "Присяжные переводы"
  },
  supportServiceTranslationDesc: {
    pl: "Oferujemy usługi tłumaczeń przysięgłych dokumentów niezbędnych w procesach administracyjnych, prawnych i biznesowych.",
    en: "We offer certified translation services for documents necessary in administrative, legal, and business processes.",
    uk: "Ми пропонуємо послуги присяжних перекладів документів, необхідних в адміністративних, юридичних та бізнес-процесах.",
    ru: "Мы предлагаем услуги присяжных переводов документов, необходимых в административных, юридических и бизнес-процессах."
  },
  
  // Tax Services
  taxServiceBasicTitle: {
    pl: "Księgowość - pakiet BASIC",
    en: "Accounting - BASIC package",
    uk: "Бухгалтерія - пакет BASIC",
    ru: "Бухгалтерия - пакет BASIC"
  },
  taxServiceBasicDesc: {
    pl: "Podstawowa obsługa księgowa dla małych firm i jednoosobowych działalności gospodarczych. Obejmuje prowadzenie KPiR lub ryczałtu oraz deklaracje podatkowe.",
    en: "Basic accounting service for small businesses and sole proprietorships. Includes KPiR or flat-rate accounting and tax declarations.",
    uk: "Базове бухгалтерське обслуговування для малих підприємств та індивідуальних підприємців. Включає ведення KPiR або єдиного податку та податкові декларації.",
    ru: "Базовое бухгалтерское обслуживание для малых предприятий и индивидуальных предпринимателей. Включает ведение KPiR или единого налога и налоговые декларации."
  },
  taxServiceStandardTitle: {
    pl: "Księgowość - pakiet STANDARD",
    en: "Accounting - STANDARD package",
    uk: "Бухгалтерія - пакет STANDARD",
    ru: "Бухгалтерия - пакет STANDARD"
  },
  taxServiceStandardDesc: {
    pl: "Kompleksowa obsługa księgowa dla rozwijających się firm. Obejmuje pełną księgowość, deklaracje podatkowe, ZUS oraz podstawowe doradztwo.",
    en: "Comprehensive accounting service for developing companies. Includes full accounting, tax declarations, ZUS, and basic advisory.",
    uk: "Комплексне бухгалтерське обслуговування для компаній, що розвиваються. Включає повну бухгалтерію, податкові декларації, ZUS та базові консультації.",
    ru: "Комплексное бухгалтерское обслуживание для развивающихся компаний. Включает полную бухгалтерию, налоговые декларации, ZUS и базовые консультации."
  },
  taxServicePremiumTitle: {
    pl: "Księgowość - pakiet PREMIUM",
    en: "Accounting - PREMIUM package",
    uk: "Бухгалтерія - пакет PREMIUM",
    ru: "Бухгалтерия - пакет PREMIUM"
  },
  taxServicePremiumDesc: {
    pl: "Pełna obsługa księgowa i doradztwo podatkowe dla średnich i dużych firm. Obejmuje księgowość, kadry, płace, sprawozdawczość oraz strategiczne doradztwo.",
    en: "Full accounting service and tax advisory for medium and large companies. Includes accounting, HR, payroll, reporting, and strategic advisory.",
    uk: "Повне бухгалтерське обслуговування та податкове консультування для середніх та великих компаній. Включає бухгалтерію, кадри, зарплату, звітність та стратегічні консультації.",
    ru: "Полное бухгалтерское обслуживание и налоговое консультирование для средних и крупных компаний. Включает бухгалтерию, кадры, зарплату, отчетность и стратегические консультации."
  },
  taxServicePITTitle: {
    pl: "Rozliczenia roczne PIT",
    en: "Annual PIT settlements",
    uk: "Річні розрахунки PIT",
    ru: "Годовые расчеты PIT"
  },
  taxServicePITDesc: {
    pl: "Profesjonalne przygotowanie rocznych zeznań podatkowych PIT dla osób fizycznych, z uwzględnieniem wszystkich możliwych ulg i odliczeń.",
    en: "Professional preparation of annual PIT tax returns for individuals, taking into account all possible reliefs and deductions.",
    uk: "Професійна підготовка річних податкових декларацій PIT для фізичних осіб, з урахуванням усіх можливих пільг і відрахувань.",
    ru: "Профессиональная подготовка годовых налоговых деклараций PIT для физических лиц, с учетом всех возможных льгот и вычетов."
  }
};

export const getTranslation = (key: TranslationKey, language: Language): string => {
  return translations[key][language] || translations[key].en;
};